import * as React from 'react';
import { WeighBridgePanel } from './WeighBridgePanel';
import configData from "../config.json";
import { GetToken, GetUserId, GetSession } from '../components/Session';
import { CreateNewTransaction, GetTransactionData, GetTransactionFromFirstWeigh, CreateTransactionFromTruck, GetLoadTypeName } from "./Transaction";
import {
    GetField, GetSetting, GetRawSetting, UpdateWeights, UpdateLights, UpdateRemoteDisplay, LightClicked, UpdateCameras, GetStreamingUrl, GetCurrentWB,
    GetSignature, GetEftpos, DefaultLoadType, CheckLoadAgainstTare, GetSelectionItems, GetNextPromptType, PostTransaction, GenerateStateEvent, SetRemoteDisplayMessage,
    GetWarningText, IsAutomated, GetActiveScales, PostEventLog, IsWeighedLoad, GetNextMixedPrompt, GetNextVisitorPrompt, CreateOffence, DeleteLocalFirstWeigh //, LogVisitor
} from "./Helpers";
import { DocketPreview } from "./DocketPreview";
import { TextBox } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { AutoComplete } from "@progress/kendo-react-dropdowns";
import { OperatorData } from "./OperatorData";
import { Dialog, DialogActionsBar, Window } from "@progress/kendo-react-dialogs";
import { FirstWeighs } from "./FirstWeighs";
import { Cameras } from "./Cameras";
import { Logs } from "./Logs";
import Iframe from 'react-iframe'
import { Signatures } from './Signature';
import { ItemSelector } from './ItemSelector';
import { Eftpos } from './Eftpos';
import { Preview } from './Preview';
import { VirtualKeyboardEntry } from './VirtualKeyboardEntry';
import { WeighbridgeHeader } from './WeighbridgeHeader';
import { MixedProducts } from './MixedProducts';
import { JobTonnage } from './JobTonnage';
import { HIDProcess } from './HIDProcess';
import { TruckConfig } from './TruckConfiguration';
import { filterBy } from "@progress/kendo-data-query";
import { Reprint } from './Reprint';
import { GetCloudLogin } from "../WeighBridge/Helpers";
import { Label, Error } from '@progress/kendo-react-labels';
import { useNavigate } from "react-router-dom";
import $ from "jquery";

const Weighbridge = () => {
    const navigate = useNavigate();
    if (localStorage.getItem("userid") === null) navigate("/logout");
    const site = React.useRef();
    const [weights, setWeights] = React.useState([0, 0, 0, 0, 0, 0]);
    const businessData = React.useRef(null);
    const [lights, setLights] = React.useState({ Lights: [], Gates: [] });
    const [cameraImages, setCameraImages] = React.useState([]);
    const [display, setDisplay] = React.useState({ Text: "", Weight: 0, MessageTime: 0, WeightTime: 1000 });
    const [showWeightSlider, setShowWeightSlider] = React.useState(false);
    const [showKeyboardIcon, setShowKeyboardIcon] = React.useState(false);
    const [docket, setDocket] = React.useState("");
    const [loadType, setLoadType] = React.useState("");
    const weight = React.useRef([0, 0, 0, 0, 0, 0]);
    const wbSettings = React.useRef({ Decks: 1, MaxWeight: 60 });
    const trans = React.useRef();
    const firstWeigh = React.useRef();
    const settings = React.useRef("");
    const regoList = React.useRef();
    const [rego, setRego] = React.useState("");
    const [regoDisabled, setRegoDisabled] = React.useState(false);
    const currentRego = React.useRef("");
    const currentSplit = React.useRef(0);
    const allOptions = React.useRef();
    const jobOptions = React.useRef([]); // allOptions filtered for a job
    const [showSplit, setShowSplit] = React.useState(false);
    const [dialogTitle, setDialogTitle] = React.useState("");
    const [dialogMessage, setDialogMessage] = React.useState("");
    const [dialogYesText, setDialogYesText] = React.useState("Yes");
    const [dialogNoText, setDialogNoText] = React.useState("No");
    const [dialogError, setDialogError] = React.useState("");
    const [showRegoDiv, setShowRegoDiv] = React.useState(true);
    const [showLookup, setShowLookup] = React.useState(true);
    const [showOffence, setShowOffence] = React.useState(true);
    const [showLogSplit, setShowLogSplit] = React.useState(false);
    const [splitOn, setSplitOn] = React.useState(false);
    const [showRestart, setShowRestart] = React.useState(true);
    const [showReprint, setShowReprint] = React.useState(true);
    const [showReprintLast, setShowReprintLast] = React.useState(true);
    const [showSync, setShowSync] = React.useState(true);
    const [showAccept, setShowAccept] = React.useState(false);
    const [showOptions, setShowOptions] = React.useState(false);
    const [showFirstWeighTable, setShowFirstWeighTable] = React.useState(false);
    const [showCameras, setShowCameras] = React.useState(false);
    const [showANPR, setShowANPR] = React.useState(false);
    const loadTypes = [{ label: "STANDARD" }, { label: "M3" }, { label: "STOREDTARE" }, { label: "FIRST" }, { label: "SECOND" }, { label: "REGO" }, { label: "MIXED" }, { label: "VISITOR" }, { label: "SIMPLE" }];
    const WasteStreams = [{ code: 1, name: "NA" }, { code: 2, name: "Domestic Waste" }, { code: 3, name: "Other Domestic Waste" }, { code: 4, name: "Council Waste" }, { code: 5, name: "Garden Organics" }];
    const DestinationPurposes = [{ code: 1, name: "NA" }, { code: 2, name: "Disposal" }, { code: 3, name: "Recycling" }, { code: 4, name: "Recovery" }, { code: 5, name: "Re-use" }];
    const [showLoadType, setShowLoadType] = React.useState(true);
    const [loadTypeDisabled, setLoadTypeDisabled] = React.useState(false);
    const [showTraffic, setShowTraffic] = React.useState(true);
    const [showRemote, setShowRemote] = React.useState(true);
    const [showOffenceDlg, setShowOffenceDlg] = React.useState(false);
    const displayingSplitWeight = React.useRef(false);
    const showAllJobs = React.useRef(false);
    const overloadOverride = React.useRef(false);
    const truckJobs = React.useRef([]);
    const selectedTruck = React.useRef();
    const dialogCb = React.useRef(null);
    const dialogNoCb = React.useRef(null);
    const regoFound = React.useRef(false);
    const [regos, setRegos] = React.useState([]);
    const mode = React.useRef("normal");
    const NA = { "id": "1", "name": "NA" };
    const [options, setOptions] = React.useState({
        jobs: [NA],
        products: [NA],
        productCategories: [NA],
        customers: [NA],
        sources: [NA],
        destinations: [NA],
        truckConfigs: [NA],
        selectedJob: NA,
        selectedProduct: NA,
        selectedProductCategory: NA,
        selectedCustomer: NA,
        selectedSource: NA,
        selectedDestination: NA,
        selectedTruckConfig: NA,
        loadType: "",
        deliveryAddress: "",
        haulage: 0
    });
    const [streamUrl, setStreamUrl] = React.useState();
    const [signature, setSignature] = React.useState(); // signature businessdata object
    const [showHidProcess, setShowHidProcess] = React.useState(false);
    const [showTruckConfig, setShowTruckConfig] = React.useState(false);
    const [showSignaturePad, setShowSignaturePad] = React.useState(false); // display signature pad on screeen
    const [useTouchScreenSignature, setUseTouchScreenSignature] = React.useState(true); // use the kiosk touchscreen rather than Topaz
    const [voucher, setVoucher] = React.useState("");
    const [showTakeControl, setShowTakeControl] = React.useState(false);
    const [takeControl, setTakeControl] = React.useState("");
    const serverState = React.useRef({hasControl: true, isIdle: true});
    const serverData = React.useRef();
    const weightStatus = React.useRef();
    const prompt = React.useRef("");
    const product = React.useRef();
    const [activeWeighbridge, setActiveWeighbridge] = React.useState("");
    const [activeScales, setActiveScales] = React.useState();
    const defaultProduct = React.useRef(); // default values for products from product NA(1)
    const activeScale = React.useRef();
    const [scaleDisabled, setScaleDisabled] = React.useState(false);
    const [updateFirstWeighs, setUpdateFirstWeighs] = React.useState(new Date());
    const [fwClass, setFwClass] = React.useState("");
    const [logUpdate, setLogUpdate] = React.useState(5);
    const [showReprintDialog, setShowReprintDialog] = React.useState(false);
    const commentPrompted = React.useRef(false);
    const transactionWait = React.useRef({ "ready": true, "timer": null }); // data to delay start of transaction until previous truck leaves
    const cloudToken = React.useRef("");
    const lastUpdated = React.useRef(new Date().valueOf());
    const [reprintText, setReprintText] = React.useState("");
    const [offenceRego, setOffenceRego] = React.useState("");
    const [offenceDesc, setOffenceDesc] = React.useState("");
    const [offenceRegoError, setOffenceRegoError] = React.useState("");
    const [offenceDescError, setOffenceDescError] = React.useState("");
 
    // item selector
    const [showItemSelector, setShowItemSelector] = React.useState(false);
    const [itemSelectorOptions, setItemSelectorOptions] = React.useState([]);
    const [itemSelectorCallback, setItemSelectorCallback] = React.useState();
    const [itemSelectorType, setItemSelectorType] = React.useState("");
    const [itemSelectorShowCodes, setItemSelectorShowCodes] = React.useState(false);
    const [itemSelectorLayout, setItemSelectorLayout] = React.useState("default");
    const [itemShowKeyboard, setItemShowKeyboard] = React.useState(true);

    // mixed products
    const [showMixedProducts, setShowMixedProducts] = React.useState(false);

    // eftpos
    const [eftposCommand, setEftposCommand] = React.useState();
    const [eftposData, setEftposData] = React.useState();

    // docket preview
    const previewOn = React.useRef(false);
    const [showPreview, setShowPreview] = React.useState(previewOn.current);
    const [transaction, setTransaction] = React.useState(); // DTO.Transaction data
    const [transInfo, setTransInfo] = React.useState(); // transaction info, eg rego and tares

    // virtual keyboard text entry
    const [textEntryType, setTextEntryType] = React.useState("");
    const [textEntryInitial, setTextEntryInitial] = React.useState("");
    const [textEntryExtra, setTextEntryExtra] = React.useState("");
    const [textEntryExtra2, setTextEntryExtra2] = React.useState("");
    const [jobTonnage, setJobTonnage] = React.useState(false);
    const [cameraPos, setCameraPos] = React.useState({ "left": 490, "top": 63, "width": 510, "height": 220 });
    var running = 0;
    const automatedTimer = React.useRef(null);
    const bdTimer = React.useRef(null);
    const dialogTimer = React.useRef(null);
    const lastRefreshed = React.useRef(0);
    const nonWBTimer = React.useRef(null); // timer to restart if non-weighbridge rego was scanned
    const serverMessage = React.useRef("");

    const [layout, setLayout] = React.useState([
        { "field": "splitWeigh", "label": "Split Weigh", "isVisible": true, },
        { "field": "job", "label": "Job", "isVisible": true, },
        { "field": "product", "label": "Product", "isVisible": true, },
        { "field": "customer", "label": "Customer", "isVisible": true, },
        { "field": "destination", "label": "Destination", "isVisible": true, },
        { "field": "source", "label": "Source", "isVisible": true, },
        { "field": "truckConfig", "label": "Truck Config", "isVisible": true, },
        { "field": "deliveryAddress", "label": "Delivery Address", "isVisible": true, },
        { "field": "haulage", "label": "Haulage", "isVisible": true, },
        { "field": "loadType", "label": "Load Type", "isVisible": true, },
        { "field": "standard", "label": "Standard", "isVisible": true, },
        { "field": "m3", "label": "m3", "isVisible": true, },
        { "field": "stored", "label": "Stored", "isVisible": true, },
        { "field": "first", "label": "First", "isVisible": true, },
        { "field": "second", "label": "Second", "isVisible": true, },
        { "field": "rego", "label": "Rego", "isVisible": true, },
        { "field": "mixed", "label": "Mixed", "isVisible": true, },
        { "field": "visitor", "label": "Visitor", "isVisible": true, },
        { "field": "simple", "label": "Simple", "isVisible": true, },
        { "field": "lookup1st", "label": "Lookup 1st Weight", "isVisible": true, },
        { "field": "logSplit", "label": "Log Split Weight", "isVisible": true, },
        { "field": "restart", "label": "Restart", "isVisible": true, },
        { "field": "reprint", "label": "Reprint", "isVisible": true, },
        { "field": "accept", "label": "Accept", "isVisible": true, },
        { "field": "tare", "label": "Tare", "isVisible": true, },
        { "field": "paymentType", "label": "Payment Type", "isVisible": true, },
        { "field": "direction", "label": "Goods Direction", "isVisible": true, },
        { "field": "chargeRate", "label": "Charge Rate", "isVisible": true, },
        { "field": "vehicleOwner", "label": "Vehicle Owner", "isVisible": true, },
        { "field": "delivery", "label": "Delivery Fee (Ex GST)", "isVisible": true, },
        { "field": "fee", "label": "Penalty Fee (Ex GST)", "isVisible": true, },
        { "field": "comment", "label": "Comment", "isVisible": true, },
        { "field": "print", "label": "Print Docket", "isVisible": true, },
        { "field": "back", "label": "Back", "isVisible": true, },
        { "field": "clearSignature", "Clear": "Accept", "isVisible": true, },
        { "field": "saveSignature", "Save": "Accept", "isVisible": true, },
        { "field": "cash", "label": "Cash", "isVisible": true, },
        { "field": "account", "label": "Account", "isVisible": true, },
        { "field": "cheque", "label": "Cheque", "isVisible": true, },
        { "field": "eftpos", "label": "EFTPOS", "isVisible": true, },
        { "field": "creditCard", "label": "Credit Card", "isVisible": true, },
        { "field": "voucher", "label": "Voucher", "isVisible": true, },
        { "field": "owing", "label": "Amount Owing", "isVisible": true, },
        { "field": "tendered", "label": "Amount Tendered", "isVisible": true, },
        { "field": "change", "label": "Change", "isVisible": true, },
        { "field": "paymentSubtotal", "label": "Subtotal", "isVisible": true, },
        { "field": "paymentFees", "label": "Fees", "isVisible": true, },
        { "field": "paymentDiscounts", "label": "Discounts", "isVisible": true, },
        { "field": "paymentOwing", "label": "Owing", "isVisible": true, },
        { "field": "recapture", "label": "Recapture Rego", "isVisible": true, },
        { "field": "reprintLast", "label": "Reprint Last", "isVisible": true, },
    ]);

    React.useEffect(() => {
        GetCloudLogin((cred) => { cloudToken.current = (cred === "" ? "" : cred.token) });
        let url = configData.SERVER_URL + "apiv7/userinterfaces?$filter=viewName eq 'WeighBridge'";
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };
        fetch(url, init).then(response => response.json()).then(d => {
            setLayout(d);
        }).catch((error) => {
            console.log("User Interfaces fetch error: " + error.message);
        });
        url = `${configData.SERVER_URL}apiv7/sites/${GetSession().SiteID}`;
        fetch(url, init).then(response => response.json()).then(d => {
            site.current = d;
        }).catch((error) => {
            console.log("Sites fetch error: " + error.message);
        });
        url = `${configData.SERVER_URL}apiv7/private/getsitesettings?siteId=${GetSession().SiteID}`;
        fetch(url, init).then(response => response.json()).then(d => {
            if (d.length > 0) {
                settings.current = d;
                mode.current = String(GetRawSetting(d, "Mode")).toLowerCase();
                wbSettings.current = {
                    Decks: GetRawSetting(d, "IsMultiDeckWeighbridge") ? GetRawSetting(d, "NoOfDecks") : 1,
                    MaxWeight: GetRawSetting(d, "MaximumWeight")
                };
                if (GetRawSetting(d, "ShowFirstWeighTable")) setShowFirstWeighTable(true);
                setItemSelectorShowCodes(GetRawSetting(d, "ItemSelectorShowCodes"));
                setShowSync(!GetRawSetting(d, "DisableSyncNowbutton"));
                setShowReprint(GetRawSetting(d, "UseReprintMenu"));
                setShowReprintLast(GetRawSetting(d, "UseReprintLastMenu"));
                setShowOffence(GetRawSetting(d, "UseOffenceMenu"));
                setShowLookup(!GetRawSetting(d, "HideLookup1stWeigh"));
                setShowCameras(!GetRawSetting(d, "HideSurveillanceCameras"));
                setShowKeyboardIcon(GetRawSetting(d, "ShowKeyboardButtonforRego"));
                setShowANPR(!GetRawSetting(d, "HideANPRCamera"));
                setShowLoadType(true);
                setShowHidProcess(GetRawSetting(d, "InitiateWeighingProcessByDriverWithHID"));
                setLogUpdate(GetRawSetting(d, "LogUpdateInterval"));
                ChangeLoadType(DefaultLoadType(d));
                setLoadTypeDisabled(!GetRawSetting(d, "AllowLoadTypeSelection"));
                if (GetRawSetting(d, "HideSurveillanceCameras")) {
//                    $("#RegoDiv").addClass("RegoNoCameras");
//                    $(".loadTypesDiv").addClass("LoadTypeNoCameras");
//                    setFwClass("FirstWeighNoCameras");
                }
            }
        }).catch((error) => {
            console.log("Get site settings fetch error: " + error.message);
        });
        GetRegoList();
        RefreshOptions();
        url = `${configData.SERVER_URL}apiv7/products/1`;
        fetch(url, init).then(response => response.json()).then(d => {
            defaultProduct.current = d;
            product.current = d;
        });
        localStorage.setItem("WBInUse", "false");
        if (running == 0) {
            require('./WeighBridge.scss');
            require('./Custom.scss');
            running = 1;
            trans.current = CreateNewTransaction(settings.current);
            GetBusinessData();
            GenerateStateEvent("Reset", "");
            window.addEventListener("beforeunload", CheckUnsavedData);
            window.addEventListener("unload", TransactionCancelled);
            let cp = localStorage.getItem("WBCameras");
            if (cp !== null) {
                let cpj = JSON.parse(cp);
                if (cpj.height < 20) cpj.height = 220;
                setCameraPos(cpj);
            }
            $("#Rego").focus();
        }
        return () => { // kill any timers when leaving page
            if (automatedTimer.current !== null) clearTimeout(automatedTimer.current); 
            if (bdTimer.current !== null) clearTimeout(bdTimer.current); 
            if (dialogTimer.current !== null) clearTimeout(dialogTimer.current); 
            window.removeEventListener("beforeunload", CheckUnsavedData);
            window.removeEventListener("unload", TransactionCancelled);
        }
    }, []);

    const GetRegoList = () => {
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };
        let url = `${configData.SERVER_URL}clientapi/weighbridge/getregos`;
        fetch(url, init).then(response => response.json()).then(d => {
            regoList.current = d;
            setRegos(d);
        });
    }

    const UseAllOptions = (d) => {
        let o = { ...options };
        o.jobs = d.jobs;
        o.products = d.weighedProducts;
        o.customers = d.customers;
        o.destinations = d.destinations;
        o.sources = d.sources;
        o.truckConfigs = d.vehicleConfigurations;
        o.productCategories = d.productCategories;
        o.vehicles = d.vehicles;
        setOptions(o);
        //        TestItemSelector(d);
    }

    const GetBusinessData = () => {
        var url = `${configData.SERVER_URL}apiv7/businessdata?prm=wb&$filter=isActive eq true and siteId eq ${GetSession().SiteID}&$orderby=prompt`;
        const init = {
            method: 'GET',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() }
        }
        fetch(url, init).then(response => response.json()).then(d => {
            if (businessData.current === null) {
                let act = GetActiveScales(d);
                if (act.length > 1 && GetSetting(settings, "UseTwoScaleOption")) {
                    setActiveScales(act);
                    let wb = GetCurrentWB(d);
                    setActiveWeighbridge(wb);
                    activeScale.current = wb;
                }
            }
            let old = JSON.stringify(businessData.current);
            let upd = JSON.stringify(d);
            if (old != upd || new Date().getTime() > lastRefreshed.current + 30000) {
                businessData.current = d;
                lastRefreshed.current = new Date().getTime();
                let ws = UpdateWeights(d, weights, wbSettings.current.Decks, activeScale.current);
                if (trans.current !== null && trans.current.registration1 !== "" && trans.current.registration1 !== undefined && weight.current[1] > 0 && ws.weights[0] <= GetSetting(settings, "MinimumWeight")) {
                    Restart();
                }
                if (GetSetting(settings, "EnableTakeControl")) {
                    let k = d.find(x => x.dataType === "kiosk");
                    if (k !== null) {
                        let j = JSON.parse(k.validationMessage);
                        if (j !== undefined) {
                            serverState.current = j;
                            if ((!j.isLocal || (j.isLocal && !j.hasControl)) && j.isIdle) setShowTakeControl(true);
                            if ((j.isLocal && j.hasControl && showTakeControl) || !j.isIdle) setShowTakeControl(false);
                            if (j.hasControl && takeControl !== "Take Control") setTakeControl("Take Control");
                            if (!j.hasControl && takeControl !== "Release Control") setTakeControl("Release Control");
                        }
                    }
                }
                if (displayingSplitWeight.current) {
                    weight.current[0] = ws.weights[0];
                } else {
                    weight.current = ws.weights;
                }
                setWeights(weight.current);
                let w = ws.weights;
                if (!transactionWait.current.ready && w[0] <= GetSetting(settings, "MinimumWeight") && transactionWait.current.timer === null) {
                    transactionWait.current.timer = setTimeout(() => {
                        transactionWait.current.timer = null;
                        transactionWait.current.ready = true;
                    }, GetSetting(settings, "TransactionWaitTime"));
                }
                if (nonWBTimer.current !== null && w[0] >= GetSetting(settings, "MinimumWeight")) {
                    clearTimeout(nonWBTimer.current);
                    nonWBTimer.current = null;
                }
                weightStatus.current = ws.status;
                if (w !== undefined && !previewOn.current) {
                    let lt = trans.current.loadType;
                    let sh = (w[0] >= GetSetting(settings, "MinimumWeight")) && weightStatus.current.IsStable && currentRego.current !== "" && lt !== "";
                    if (sh && IsAutomated(mode.current) && w[0] > 0) automatedTimer.current = setTimeout(AcceptClicked(), 1000);
                    if (lt === "COUNTED" || lt === "VISITOR" || lt === "STANDARD" || lt === "MIXED") sh = true;
                    if (lt === "COUNTED" && (trans.current.selectedMixedProducts === undefined || trans.current.selectedMixedProducts.length < 1)) sh = false;
                    if (lt === "MIXED" && (trans.current.selectedMixedProducts === undefined || trans.current.selectedMixedProducts.length < 1 || trans.current.productId < 1)) sh = false;
                    setShowAccept(sh);
                    setShowOptions(sh && GetSetting(settings, "AllowTranslinkSelection"));
                    if (lt === "COUNTED" || lt === "MIXED" || lt === "SIMPLE" || lt === "REGO" || lt === "VISITOR" || lt === "STANDARD") {
                        setShowFirstWeighTable(false);
                        setShowLookup(false);
                    } else {
                        setShowLogSplit(sh && (wbSettings.current.Decks === 1) && displayingSplitWeight.current);
                    }
                    var shMixed = lt === "MIXED" || lt === "COUNTED";
                    if (shMixed !== showMixedProducts) setShowMixedProducts(shMixed);
                }
                if (w !== undefined && serverData.current !== undefined) {
                    let max = GetSetting(settings, "MaximumWeight");
                    if (serverData.current.truck !== undefined && serverData.current.truck !== null && serverData.current.truck.maxLoad > 0) max = serverData.current.truck.maxLoad;
                    if (GetSetting(settings, "EnableOverloadTransaction")) max = (1 + GetSetting(settings, "MaxLoadExceedAllowance") / 100) * max;
                    if (w[0] > max) {
                        let msg = "";
                        let rmt = "";
                        if (serverData.current.truck.tare === 0 && serverData.current.truck.loadType.toUpperCase() === "STOREDTARE") {
                            msg = "The selected vehicle stored tare is zero in the system. Cannot proceed with the transaction.";
                            trans.current.eventType = 6;
                            trans.current.eventLogError = "Stored Tare Transaction Error";
                            rmt = "Leave";
                        } else {
                            let over = Math.round((serverData.current.truck.maxLoad - w[0]) * 100) / 100;
                            msg = `Vehicle Maximum Exceeded. You must tip off. <br/>Maximum truck load is ${serverData.current.truck.maxLoad}t, overloaded by ${Math.abs(over)}t.`;
                            trans.current.eventType = 7;
                            trans.current.eventLogError = "Overload";
                            rmt = "TipOff";
                        }
                        ShowError(msg);
                        trans.current.eventLogDescription = msg;
                        PostEventLog(trans.current);
                        GenerateStateEvent("leave", rmt);
                        Restart();
                        SetBusinessDataTimer();
                        return false;
                    }
                }
                setLights(UpdateLights(d));
                setDisplay(UpdateRemoteDisplay(d));
                if (currentRego.current === "" && !trans.current.suppressScanning && transactionWait.current.ready) CheckScanners(d);
                setCameraImages(UpdateCameras(d, settings));
                setEftposData(GetEftpos(d));
                let sig = GetSignature(d);
                if (sig !== undefined) {
                    setSignature(sig);
                }
                let sm = d.find(obj => obj.dataType === "servermessage");
                if (sm !== undefined && sm.value !== serverMessage.current) serverMessage.current = sm.value;

            }
            if (rego === "" && serverMessage.current !== "") ProcessServerMessages();
            SetBusinessDataTimer();
        }).catch((error) => {
            console.log("GetBusinessData fetch error: " + error.message);
            SetBusinessDataTimer();
        });
    }

    const SetBusinessDataTimer = () => {
        bdTimer.current = setTimeout(() => GetBusinessData(), 1000);
    }

    const CheckScanners = (d) => {
        let sc = d.find(obj => (obj.dataType === "hidscanner" || obj.dataType === "ibutton" || obj.dataType === "anpr" || obj.dataType === "rfid") && obj.value !== "");
        if (sc === undefined) return;

        let init = {
            method: 'PUT',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() }
        }
        let url = `${configData.SERVER_URL}clientapi/device/putcommand?businessdataid=${sc.businessDataId}&command=Clear`;
        fetch(url, init).catch((error) => {
            console.log("Check scanners PUT fetch error: " + error.message);
        });
        init = {
            method: 'GET',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() }
        }
        if (GetSetting(settings, "InitiateWeighingProcessByDriverWithHID")) {
            let url = `${configData.SERVER_URL}apiv7/drivers?$filter=tagid eq '${sc.value}'`;
            fetch(url, init).then(response => response.json()).then(d => {
                if (d.length === 0) {
                    setDialogError("Your card number not present/in-active in the system. Please check  with site admin.");
                    return;
                }
                trans.current.driverId = d[0].driverId;
                PromptForText("Plant Number", "Hi " + d[0].name);
            }).catch((error) => {
                console.log("Check scanners driver fetch error: " + error.message);
            });

        } else {
            let timeout = GetSetting(settings, "TruckStayTimeOut");
            if (sc.dataType.toLowerCase() === "anpr") {
                setRego(sc.value);
                if (GetSetting(settings, "PromptToConfirmRego")) {
                    trans.current.stateEvent = sc.stateEvent;
                    ShowDialog(`Is ${rego} the correct registration`, RegoConfirmed, "Confirm Registration");
                } else {
                    trans.current.suppressScanning = true;
                    if (timeout > 0) nonWBTimer.current = setTimeout(AbortAndOpenGate, timeout * 60000);
                    CheckRego(sc.value, sc.stateEvent);
                    RefreshOptions();
                }
                return;
            }
            url = `${configData.SERVER_URL}apiv7/trucks?$filter=TagId eq '${sc.value}'`;
            fetch(url, init).then(response => response.json()).then(d => {
                let rego = "";
                if (d.length > 0) rego = d[0].name;
                setRego(rego);
                if (GetSetting(settings, "PromptToConfirmRego")) {
                    trans.current.stateEvent = sc.stateEvent;
                    ShowDialog(`Is ${rego} the correct registration`, RegoConfirmed, "Confirm Registration");
                } else {
                    trans.current.suppressScanning = true;
                    if (timeout > 0) nonWBTimer.current = setTimeout(AbortAndOpenGate, timeout * 60000);
                    CheckRego(rego, sc.stateEvent);
                    RefreshOptions();
                }
            }).catch((error) => {
                console.log("Check scanners truck get fetch error: " + error.message);
            });
        }
    }

    const RegoConfirmed = () => {
        setRegoDisabled(true);
        CheckRego(rego, trans.current.stateEvent);
    }

    const RegoChanged = (e) => {
        trans.current.suppressScanning = e.value !== "";
        setRegos(filterBy(regoList.current, {
            value: e.value,
            operator: "startswith",
            ignoreCase: true,
        }));
        setRego(e.value.toUpperCase());
        CheckRego(e.value.toUpperCase());
        let x = new Date().valueOf() - lastUpdated.current;
        if (x > 10000) RefreshOptions();
    }

    const FirstWeighSelected = (e) => {
        setLoadTypeDisabled(!GetSetting(settings, "AllowLoadTypeSelection"));
        RegoChanged(e);
    }

    const CheckRego = (rego, event = "", ignore = false) => {
        if (regoList.current !== undefined && !regoList.current.includes(rego)) {
            if (rego === "") {
                UseAllOptions(allOptions.current);
                currentRego.current = "";
                if (trans.current !== null) trans.current.suppressScanning = false;
                regoFound.current = false;
                setShowAccept(false);
                setShowLogSplit(false);
                setShowOptions(false);
                setShowFirstWeighTable(GetSetting(settings, "ShowFirstWeighTable"));
                setShowLookup(!GetSetting(settings, "HideLookup1stWeigh"));
                setShowSplit(false);
                setLoadTypeDisabled(!GetSetting(settings, "AllowLoadTypeSelection"));
                trans.current.hasFirstWeigh = false;
                setLoadType("");
                localStorage.setItem("WBInUse", "false");
                return;
            }
            let sh = (weights[0] >= GetSetting(settings, "MinimumWeight") && loadType !== "");
            setShowLogSplit(sh && (wbSettings.current.Decks === 1) && displayingSplitWeight.current);
            setShowAccept(sh);
            setShowOptions(loadType !== "STANDARD" && loadType !== "REGO" && GetSetting(settings, "AllowTranslinkSelection"));
            setShowFirstWeighTable(false);
            ChangeLoadType("");
            if (firstWeigh.current !== null && firstWeigh.current !== undefined && firstWeigh.current.name !== rego) firstWeigh.current = undefined;
            localStorage.setItem("WBInUse", "true");
            ClearAllSelections();
            ClearSelections();
            if (trans.current === null || trans.current === undefined) trans.current = CreateNewTransaction(settings);
        }
        setShowSplit(true);
        let reg = rego.trim();
        currentRego.current = reg;
        var base = configData.SERVER_URL;
        var token = GetToken();
        var url = `${base}clientapi/weighbridge/regochanged?rego=${reg}&stateevent=${event}&ignoreoffences=${ignore}`;
        const init = {
            method: 'GET',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + token }
        }
        fetch(url, init).then(response => response.json()).then(d => {
            setShowLookup(!GetSetting(settings, "HideLookup1stWeigh"));
            let sh = (weights[0] >= GetSetting(settings, "MinimumWeight"));
            let sw = sh && (wbSettings.current.Decks === 1) && displayingSplitWeight.current;
            setShowLogSplit(sw);
            serverData.current = d;
            switch (d.result) {
                case 0: // truck found, no first weigh
                    if (String(d.truck.loadType).toUpperCase() === "STOREDTARE" && d.truck.tare === 0) {
                        GenerateStateEvent("ticketprinted", ""); // Open exit gate so truck can leave
                        let t = GetTransactionData(trans.current, site.current, settings, allOptions.current);
                        t.eventLogError = "Stored Tare Transaction Error";
                        t.eventLogDescription = "The selected vehicle has a zero stored tare in the system. Cannot proceed with the transaction.";
                        PostEventLog(t);
                        setDialogError(t.eventLogDescription);
                    }
                    regoFound.current = true;
                    firstWeigh.current = null;
                    trans.current = CreateTransactionFromTruck(d.truck, settings);
                    setShowOptions(GetSetting(settings, "AllowTranslinkSelection"));
                    if (!GetSetting(settings, "IsDirectionBasedonTruckInOut")) trans.current.direction = "IN";
                    setShowFirstWeighTable(false);
                    ChangeLoadType(d.truck.loadType);
                    setShowLookup(false);
                    setShowAccept(sh && trans.current.loadType !== "");
                    selectedTruck.current = d.truck;
                    SetTruck(d);
                    if (IsAutomated(mode.current)) DoAutomated();
                    break;
                case 1: // first weigh found
                    SetFirstWeigh(d);
                    firstWeigh.current = d.firstWeigh;
                    regoFound.current = true;
                    trans.current = GetTransactionFromFirstWeigh(d.firstWeigh, settings);
                    if (d.firstWeigh.loadType === "VISITOR") {
                        ChangeLoadType("VISITOR");
                        trans.current.visitorReason = trans.current.comment;
                    } else
                        ChangeLoadType("SECOND");
                    commentPrompted.current = trans.current.comment !== "";
                    setShowFirstWeighTable(false);
                    setShowLookup(false);
                    setShowAccept(sh && trans.current.loadType !== "");
                    if (wbSettings.current.Decks === 1) setSplitOn(trans.current.tare2 > 0 || trans.current.tare3 > 0 || trans.current.tare4 > 0 || trans.current.tare5 > 0);
                    if (IsAutomated(mode.current)) DoAutomated();
                    break;
                case 3: // offence found
                    if (!GetSetting(settings, "OffOffenceCommentsAlert")) {
                        ShowDialog("<h3>This vehicle has offences:</h3><p>" + String(d.message).replace("\r\n", "<br/>") + "</p>", OffencesOk, "Are you sure you want to proceed for transaction?", AbortAndOpenGate);
                    }
                    break;
                case 4:
                    ShowError("Unknown truck not permitted on weighbridge");
                    setRego("");
                    rego.current = "";
                    return;
                case 5:
                    if (trans.current !== undefined && trans.current.truckId > 0) {
                        trans.current = CreateNewTransaction(settings);
                        ChangeLoadType("FIRST");
                        trans.current.registration1 = currentRego.current;
                        trans.current.tare = 0;
                        serverData.current = { firstWeigh: null, ...allOptions.current };
                    }
                    break;
                default:
                    trans.current.registration1 = currentRego.current;
                    trans.current.tare = 0;
                    let r = GetSetting(settings, "RejectUnknownTrucks");
                    if (currentRego.current.length > 0 && !r) {
                        ChangeLoadType("FIRST");
                    } else {
                        setLoadType("");
                    }
                    break;
            }
        }).catch((error) => {
            console.log("Check rego fetch error: " + error.message);
        });
    }

    const ChangeLoadType = loadType => {
        let lt = String(loadType).toUpperCase();
        if (lt === "STORED") lt = "STOREDTARE";
        let allowed = false;
        switch (lt) {
            case "STANDARD":
                allowed = GetSetting(settings, "UseStandardLoad");
                break;
            case "VISITOR":
                allowed = GetSetting(settings, "UseVisitor");
                break;
            case "COUNTED":
                allowed = GetSetting(settings, "UseCountedItem");
                break;
            case "REGO":
                allowed = GetSetting(settings, "UseRegoWeigh");
                break;
            case "MIXED":
                allowed = GetSetting(settings, "UseMixedLoad");
                break;
            case "STOREDTARE":
                allowed = GetSetting(settings, "UseStoredTare");
                break;
            case "FIRST":
                allowed = GetSetting(settings, "UseFirstWeigh");
                break;
            case "SECOND":
                allowed = GetSetting(settings, "UseSecondWeigh");
                break;
            case "SIMPLE":
                allowed = GetSetting(settings, "UseSimple");
                break;
            case "":
                allowed = true;
                break;
        }
        if (allowed) {
            setLoadType(lt);
            trans.current.loadType = lt;
        }
    }

    const SetFirstWeigh = (f) => {
        var o = { ...options };
        var fw = f.firstWeigh;
        ChangeLoadType("SECOND");
        o.loadType = trans.current.loadType;
        if (fw.jobId > 1) {
            SetControlsForJob(fw.jobId, f.name);
        } else {
            o.customers = allOptions.current.customers;
            o.destinations = allOptions.current.destinations;
            truckJobs.current = f.jobs;
            o.jobs = showAllJobs.current ? allOptions.current.jobs : f.jobs;
            o.products = allOptions.current.products;
            o.productCategories = allOptions.current.productCategories;
            o.sources = allOptions.current.sources;
            o.truckConfigs = allOptions.current.vehicleConfigurations;
            o.selectedCustomer = f.selectedCustomer;
            o.selectedDestination = f.selectedDestination;
            o.selectedJob = f.selectedJob;
            o.selectedProduct = f.selectedProduct;
            o.selectedProductCategory = f.selectedProductCategory;
            o.selectedSource = f.selectedSource;
            o.selectedTruckConfig = f.selectedVehicleConfiguration;
            o.deliveryAddress = "";
        }
        setOptions(o);
        if (weights[0] > GetSetting(settings, "MinimumWeight") && trans.current.loadType !== "") {
            setShowOptions(GetSetting(settings, "AllowTranslinkSelection"));
            setShowLookup(false);
            setShowLogSplit(wbSettings.current.Decks === 1 && displayingSplitWeight.current);
            setShowAccept(true);
        }
    }

    const SetTruck = (f) => {
        var o = { ...options };
        o.loadType = f.truck.loadType;
        o.customers = f.customers;
        o.destinations = f.destinations;
        truckJobs.current = f.jobs;
        if (f.selectedJob !== null && f.selectedJob.id !== "1") {
            trans.current.jobId = parseInt(f.selectedJob.id);
            SetControlsForJob(parseInt(f.selectedJob.id), f.truck.name);
        } else {
            // only set values for each entity if selected value is not 1. If not the MUSTENTER options won't work
            o.jobs = showAllJobs.current ? allOptions.current.jobs : f.jobs;
            o.products = f.products;
            o.sources = f.sources;
            o.truckConfigs = f.vehicleConfigurations;
            if (f.selectedCustomer !== null && f.selectedCustomer.id !== "1") {
                o.selectedCustomer = f.selectedCustomer;
                trans.current.customerId = parseInt(f.selectedCustomer.id);
            }
            if (f.selectedDestination !== null && f.selectedDestination.id !== "1") {
                o.selectedDestination = f.selectedDestination;
                trans.current.destinationId = parseInt(f.selectedDestination.id);
            }
            if (f.selectedSource !== null && f.selectedSource.id !== "1") {
                o.selectedSource = f.selectedSource;
                trans.current.sourceId = parseInt(f.selectedSource.id);
            }
            if (f.selectedProduct !== null && f.selectedProduct.id !== "1") {
                o.selectedProduct = f.selectedProduct;
                trans.current.productId = parseInt(f.selectedProduct.id);
            }
            if (f.selectedProductCategory !== null) trans.current.productCategoryId = parseInt(f.selectedProductCategory.id);
            if (f.selectedVehicleConfiguration !== null && f.selectedVehicleConfiguration.id !== "1") {
                o.selectedTruckConfig = f.selectedVehicleConfiguration;
                trans.current.vehicleConfigurationId = parseInt(f.selectedVehicleConfiguration.id);
            }
            setOptions(o);
        }
        if (weights[0] > GetSetting(settings, "MinimumWeight") && loadType !== "") {
            setShowOptions(GetSetting(settings, "AllowTranslinkSelection"));
            setShowLookup(false);
            setShowLogSplit(wbSettings.current.Decks === 1 && displayingSplitWeight.current);
            setShowAccept(true);
        }
    }

    const OffencesOk = () => {
        CheckRego(currentRego.current, "", true);
    }

    const LookupFirstClicked = () => {
        var url = `${configData.SERVER_URL}apiv7/FirstWeighs?$orderby=tareindate desc`;
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };
        fetch(url, init).then(response => response.json()).then(d => {
            if (d.length === 0) {
                ShowDialog("No first weighs in system", null, "");
                return;
            }
            let f = [];
            d.map(x => {
                f.push({ code: x.name, name: x.name });
            });
            setItemSelectorShowCodes(false);
            setItemSelectorLayout("default");
            ShowItemSelector(f, () => FirstWeightSelected, "First Weigh");
        }).catch((error) => {
            console.log("Lookup first fetch error: " + error.message);
        });
    }

    const FirstWeightSelected = (f, offence) => {
        setShowItemSelector(false);
        setLoadTypeDisabled(!GetSetting(settings, "AllowLoadTypeSelection"));;
        if (!f.startsWith("***")) {
            if (offence !== undefined && offence !== "") {
                CreateOffence(f, offence, GetSession().SiteID);
                setRego("");
                CheckRego("");
            } else {
                setRego(f);
                CheckRego(f);
            }
        }
    }

    const LogSplitClicked = () => {
        if (currentSplit.current > 5) return;
        if (currentSplit.current === 0 && GetSetting(settings, "OpenExitOnSplit")) GenerateStateEvent("liftboomgate", "");
        currentSplit.current++;
        weight.current[currentSplit.current] = weight.current[0];
        setWeights(weight.current);
    }

    const AcceptClicked = () => {
        if (currentRego.current.trim() === "") {
            ShowError("Please enter a registration");
            return;
        }
        let weighed = IsWeighedLoad(loadType);
        if (weight.current[0] === 0 && !IsWeighedLoad) return;
        GetDocketNumber();
        let w = weight.current;
        if (weighed) {
            let r = CheckLoadAgainstTare(serverData.current, w[0], settings);
            if (r !== "") {
                ShowError(r);
                return;
            }
            let plt = GetSetting(settings, "PromptIfBelowGVMLessThisAmount");
            if (plt != 0 && trans.current.maxLoad > 0 && w[0] + plt < trans.current.maxLoad && trans.current.lowLoadConfirmed !== 1) {
                let lt = Math.round((trans.current.maxLoad - w[0]) * 100) /  100;
                ShowDialog(`<p>Your gross weight is ${lt}t less than your maximum GVM.</p><p>Click No to cancel transaction.</p>Do you want to continue? `, LowLoadYes, "Truck is not fully loaded", LowLoadNo);
                return;
            }
        }
        // capture tare on first weigh logic
        if (weighed) {
            if (GetSetting(settings, "IsCaptureMaxLoadonFirstWeigh")) {
                if (loadType === "FIRST" && trans.current.truckId <= 1 && trans.current.maxLoadEntered === 0) {
                    setItemSelectorLayout("numeric");
                    PromptForText("Maximum Load");
                    return;
                }
            }
        }

        // In PromptCommentBeforeWeight mode, comment should be prompted first and only for second weighs
        if (GetSetting(settings, "UseCommentPad") && GetSetting(settings, "PromptCommentBeforeWeight") && !commentPrompted.current && loadType === "SECOND") {
            PromptForComment();
            return;
        }

        if (!CheckStoredTare()) return;

        // overload logic
        if (weighed && !CheckOverload()) return;

        if (trans.current.orderNumberRequired && trans.current.orderNumber === "") {
            if (options.selectedJob !== undefined && options.selectedJob.id !== "1" && !trans.current.orderNumberRequiredPerTxn) {
                if (!(loadType === "FIRST" && GetSetting(settings, "IgnoreFirstWeighEntityPrompts"))) {
                    PromptForText("Order Number");
                    return;
                }
            } else {
                if (options.selectedJob !== undefined && options.selectedJob.data !== "") {
                    trans.current.orderNumber = options.selectedJob.data;
                } else {
                    if (!(loadType === "FIRST" && GetSetting(settings, "IgnoreFirstWeighEntityPrompts"))) {
                        PromptForText("Order Number");
                        return;
                    }
                }
            }
        }

        // job tonnage tracker
        if (GetSetting(settings, "EnableJobTonnageTracker") && trans.current.jobId > 1 && (trans.current.tonnageConfirmed === undefined || trans.current.tonnageConfirmed < 2) && (trans.current.loadType === "SECOND" || trans.current.loadType === "STOREDTARE")) {
            if (jobOptions.current.prices !== undefined && jobOptions.current.prices.length > 0) {
                let p = jobOptions.current.prices.find(obj => obj.productId === trans.current.productId);
                if (p !== undefined && p.tonnesOrdered > 0) {
                    let left = p.tonnesOrdered - p.tonnesProcessed;
                    if (left < p.tonnesOrdered * 0.1 && trans.current.tonnageConfirmed < 1) { // less than 10% remaining for product on job
                        left = left.toFixed(2);
                        ShowDialog(`Only ${left}t left, which will be less than 10% of order quota. Do you want to continue?`, TonnageYes);
                        return;
                    }
                    if (w[0] > left) {
                        let jt = {
                            "jppId": p.jobProductPriceId,
                            "price": p.price,
                            "jobName": jobOptions.current.selectedJob.name,
                            "productName": jobOptions.current.selectedProduct.name,
                            "tonnesOrdered": p.tonnesOrdered,
                            "tonnesProcessed": p.tonnesProcessed,
                            "tonnesLeft": left,
                            "weight": weights[0]
                        }
                        setJobTonnage(jt);
                        return;
                    }
                }
            }
        }

        // trailer confirmation
        if (GetSetting(settings, "EnableTrailersConfirmation") && trans.current.loadType !== "SECOND") {
            if (trans.current.trailersConfirmed < 1) {
                PromptForText("Trailer 1 Rego", trans.current.registration2);
                return;
            }
            if (trans.current.trailersConfirmed < 2) {
                PromptForText("Trailer 2 Rego", trans.current.registration3);
                return;
            }
        }

        if (GetSetting(settings, "AllowTranslinkSelection") && trans.current.loadType !== "MIXED" && trans.current.loadType !== "VISITOR") {
            if (GetSetting(settings, "MustInputJob") && (options.selectedJob === null || options.selectedJob.id === "0" || options.selectedJob.id === "1")) {
                ShowError("Please select a job");
                return;
            }
            trans.current.jobId = parseInt(options.selectedJob === null ? "0" : options.selectedJob.id);
            if (GetSetting(settings, "MustInputProduct") && (options.selectedProduct === null || options.selectedProduct.id === "0" || options.selectedProduct.id === "1")) {
                ShowError("Please select a product");
                return;
            }
            trans.current.productId = parseInt(options.selectedProduct === null ? "0" : options.selectedProduct.id);
            if (GetSetting(settings, "MustInputCustomer") && (options.selectedCustomer === null || options.selectedCustomer.id === "0" || options.selectedCustomer.id === "1")) {
                ShowError("Please select a customer");
                return;
            }
            trans.current.customerId = parseInt(options.selectedCustomer === null ? "0" : options.selectedCustomer.id);
            if (GetSetting(settings, "MustInputDestination") && (options.selectedDestination === null || options.selectedDestination.id === "0" || options.selectedDestination.id === "1")) {
                ShowError("Please select a destination");
                return;
            }
            trans.current.destinationId = parseInt(options.selectedDestination === null ? "0" : options.selectedDestination.id);
            if (GetSetting(settings, "MustInputSource") && (options.selectedSource === null || options.selectedSource.id === "0" || options.selectedSource.id === "1")) {
                ShowError("Please select a source");
                return;
            }
            trans.current.sourceId = parseInt(options.selectedSource === null ? "0" : options.selectedSource.id);
            //trans.current.productCategoryId = parseInt(options.selectedProductCategory.id);
            trans.current.vehicleId = 1;
            if (GetSetting(settings, "MustInputVehicleConfiguration") && (options.selectedTruckConfig === null || options.selectedTruckConfig.id === "0" || options.selectedTruckConfig.id === "1")) {
                ShowError("Please select a truck configuration");
                return;
            }
            trans.current.vehicleConfigurationId = parseInt(options.selectedTruckConfig === null ? 1 : options.selectedTruckConfig.id);
        }

//        trans.current.loadType = loadType;
        let lt = loadType.toLowerCase();
        if (lt !== "counted" && lt !== "mixed") {
            trans.current.gross = w[0];
            trans.current.gross1 = w[1];
            trans.current.gross2 = w[2];
            trans.current.gross3 = w[3];
            trans.current.gross4 = w[4];
            trans.current.gross5 = w[5];
            if (lt === "first") {
                trans.current.tare = w[0];
                trans.current.tare1 = w[1];
                trans.current.tare2 = w[2];
                trans.current.tare3 = w[3];
                trans.current.tare4 = w[4];
                trans.current.tare5 = w[5];
            }
        }
        if (trans.current.payments === "") {
            if (options.selectedCustomer !== undefined && options.selectedCustomer.data !== "" && options.selectedCustomer.data !== null && options.selectedCustomer.data !== undefined) {
                let opt = JSON.parse(options.selectedCustomer.data);
                trans.current.orderNumberRequiredPerTxn = opt.RequiredPerTxn;
                trans.current.orderNumberRequired = opt.OrderNumberRequired;
                trans.current.payments = opt.Payment;
            }
            if (trans.current.payments === "") trans.current.payments = GetSetting(settings, "PaymentDefaultOption");
        }
        if (trans.current.productId > 0) RecalculatePrice();
        prompt.current = "";
        jobOptions.current = options;
        setScaleDisabled(true);
        if (GetSetting(settings, "InitiateWeighingProcessByDriverWithHID")) {
            PreviewClosed(true);
            return;
        }
        switch (loadType) {
            case "REGO":
                PromptForText("VIN");
                break;
            case "VISITOR":
                if (trans.current.visitorType === "")
                    DisplayNextPrompt("");
                else {
                    let s = "Visitor settings:<br/>";
                    s += "Type: " + trans.current.visitorType + "<br/>";
                    s += "Name: " + trans.current.visitorName + "<br/>";
                    s += "Company: " + trans.current.visitorOrg + "<br/>";
                    s += "Phone: " + trans.current.visitorPhone + "<br/>";
                    s += "Reason: " + trans.current.visitorReason + "<br/>"; 
                    s += "Is this information correct?";
                    ShowDialog(s, LogVisitorTransaction, "Please confirm", DisplayNextPrompt);
                    setDialogYesText("Yes - Logout");
                }
                break;

            default:
                DisplayNextPrompt("");
                break;
        }
    }

    const TonnageYes = () => {
        trans.current.tonnageConfirmed = 1;
        AcceptClicked();
    }

    const JobTonnageCB = (res) => {
        setJobTonnage(undefined);
        if (res !== undefined) {
            trans.current.tonnageConfirmed = 2;
            AcceptClicked();
        }
    }

    const LowLoadYes = () => {
        trans.current.lowLoadConfirmed = 1;
        AcceptClicked();
    }
    const LowLoadNo = () => {
        if (rego !== "") {
            trans.current.eventType = 7;
            trans.current.eventLogError = "Restart";
            trans.current.eventLogDescription = "Transaction Cancelled. Weight below max GVM";
            PostEventLog(trans.current);
        }
        AbortAndOpenGate();
    }
    const TransactionCancelled = () => {
        if (rego !== "") {
            trans.current.eventType = 2;
            trans.current.eventLogError = "Incomplete Transaction";
            trans.current.eventLogDescription = "Transaction Cancelled by User";
            PostEventLog(trans.current);
        }
    }
    const CheckStoredTare = () => {
        if (trans.current.loadType !== "STOREDTARE" || !GetSetting(settings, "CheckScaleWeightWithRegisterTare") || mode.current === "instructions") return true;
        if (weights[0] === 0 || weights[0] > trans.current.tare) return true;
        let msg = `Weight on Scale ${weights[0].toFixed(2)} is less than Register Tare - ${trans.current.tare.toFixed(2)} Truck Id = ${trans.current.truckId}, Product Id = ${trans.current.productId}`;
        trans.current.eventType = 6;
        trans.current.eventLogError = "Other";
        trans.current.eventLogDescription = msg;
        PostEventLog(trans.current);
        let l = trans.current.tare - weights[0];
        msg = `Weight on Scale is less than Register Tare. Register load is ${trans.current.tare.toFixed(2)}t, less by ${l.toFixed(2)}t.`;
        ShowError(msg);
        Restart();
        return false;
    }

    const RecalculatePrice = () => {
        if (trans.current.loadType === "MIXED" && trans.current.selectedMixedProducts !== null) {
        //    let wp = trans.current.selectedMixedProducts.find(obj => obj.productId === trans.current.productId);
        //    if (wp !== undefined) wp.currentAmount = weights[0] - trans.current.tare;
        }
        let t = { ...trans.current };
        var url = `${configData.SERVER_URL}clientapi/weighbridge/getupdatedprices`;
        const init = {
            method: 'POST',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify(t)
        }
        fetch(url, init).then(response => response.json()).then(d => {
            let dn = trans.current.docket;
            trans.current = d;
            trans.current.docket = dn;
            trans.current.transactionDate = new Date();
            if (d.tareInDate !== null) trans.current.tareInDate = new Date(d.tareInDate);
            if (trans.current.tareInDate === null && trans.current.loadType === "FIRST") trans.current.tareInDate = new Date();
            setTransaction(trans.current);
        }).catch((error) => {
            console.log("Recalculate price fetch error: " + error.message);
        });

    }

    // OperatorData and WeighbridgePanel post back control changes
    const ChildControlChanged = (name, value) => {
        var o = { ...options };
        switch (name) {
            case "Job":
                o.selectedJob = value.Job;
                SetControlsForJob(value.Job.id, rego);
                break;

            case "ShowAllJobs":
                showAllJobs.current = value;
                o.jobs = value ? allOptions.current.jobs : truckJobs.current;
                break;

            case "SplitWeight":
                displayingSplitWeight.current = value; 
                setSplitOn(value);
                let sh = (weights[0] >= GetSetting(settings, "MinimumWeight")) && rego !== "";
                setShowLogSplit(sh && (wbSettings.current.Decks === 1) && value);
                break;

            case "Product":
                o.selectedProduct = value.Product;
                var url = `${configData.SERVER_URL}apiv7/products/${value.Product.id}`;
                const init = {
                    method: 'GET',
                    accept: 'application/json',
                    headers: { "Authorization": "Bearer " + GetToken() }
                }
                fetch(url, init).then(response => response.json()).then(d => {
                    product.current = d;
                }).catch((error) => {
                    console.log("ChildControlChanged product fetch error: " + error.message);
                });
                break;
            case "Customer":
                o.selectedCustomer = value.Customer;
                let opt = JSON.parse(value.Customer.data);
                trans.current.orderNumberRequiredPerTxn = opt.RequiredPerTxn;
                trans.current.orderNumberRequired = opt.OrderNumberRequired;
                trans.current.payments = opt.Payment;
                break;
            case "Source": o.selectedSource = value.Source; break;
            case "Destination": o.selectedDestination = value.Destination; break;
            case "TruckConfig": o.selectedTruckConfig = value.TruckConfig; break;
        }
        setOptions(o);
    }

    const ShowDialog = (message, onYes, title = "Please confirm", onNo) => {
        setDialogTitle(title);
        setDialogMessage(message);
        dialogCb.current = onYes;
        dialogNoCb.current = onNo;
        if (onYes !== null) {
            setDialogYesText("Yes");
            setDialogNoText("No");
        }
        else {
            setDialogYesText("");
            setDialogNoText("Ok");
        }
        if (IsAutomated(mode.current) || GetSetting(settings, "InitiateWeighingProcessByDriverWithHID")) {
            dialogTimer.current = setTimeout(() => { setDialogMessage(""); }, 10000);
        }
    }

    const MessageBox = (message, title = "") => {
        setDialogTitle(title);
        setDialogMessage(message);
        setDialogYesText("");
        setDialogNoText("Ok");
        dialogCb.current = null;
        dialogNoCb.current = null;
    }

    const DialogYes = () => {
        setDialogMessage("");
        if (dialogCb !== null) dialogCb.current();
    }
    const DialogNo = () => {
        setDialogMessage("");
        if (dialogNoCb !== null && dialogNoCb.current !== undefined) dialogNoCb.current();
    }

    const ShowError = (msg) => {
        setDialogError(msg);
        if (IsAutomated(mode.current) || GetSetting(settings, "InitiateWeighingProcessByDriverWithHID")) {
//            dialogTimer.current = setTimeout(() => { setDialogError(""); }, 10000);
        }
    }

    const EftposCallback = (r, e) => {
        setEftposCommand("");
        if (e)
            MessageBox("Eftpos successful: " + r);
        else {
            if (String(r).toLowerCase().startsWith("error")) {
                ShowError(r);
            }
            else {
                ShowError("Eftpos failed");
            }
        }
    }

    const SetControlsForJob = (j, rego, cb = "") => {
        var url = `${configData.SERVER_URL}clientapi/weighbridge/jobchanged?jobid=${j}&rego=${rego}`;
        const init = {
            method: 'GET',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() }
        }
        fetch(url, init).then(response => response.json()).then(d => {
            let o = { ...options };
            o.jobs = truckJobs.current;
            o.products = d.products;
            o.productCategories = d.productCategories;
            o.customers = d.customers;
            o.destinations = d.destinations;
            o.sources = d.sources;
            o.truckConfigs = d.vehicleConfigurations;
            o.selectedJob = d.selectedJob;
            trans.current.orderNumber = d.selectedJob.data;
            o.selectedCustomer = d.selectedCustomer;
            let opt = JSON.parse(d.selectedCustomer.data);
            trans.current.orderNumberRequiredPerTxn = opt.RequiredPerTxn;
            trans.current.orderNumberRequired = opt.OrderNumberRequired;
            if (trans.current.loadType !== "SECOND") trans.current.payments = opt.Payment;
            trans.current.jobId = parseInt(d.selectedJob.id);
            if (firstWeigh.current !== undefined && firstWeigh.current !== null) {
                let v = o.customers.find(obj => { return obj.id === String(firstWeigh.current.customerId) });
                o.selectedCustomer = (v === undefined ? d.selectedCustomer : v);
                v = o.destinations.find(obj => { return obj.id === String(firstWeigh.current.destinationId) });
                o.selectedDestination = (v === undefined ? d.selectedDestination : v);
                v = o.products.find(obj => { return obj.id === String(firstWeigh.current.productId) });
                o.selectedProduct = (v === undefined ? d.selectedProduct : v);
                v = o.productCategories.find(obj => { return obj.id === String(firstWeigh.current.productCategoryId) });
                o.selectedProductCategory = (v === undefined ? d.selectedProductCategory : v);
                v = o.sources.find(obj => { return obj.id === String(firstWeigh.current.sourceId) });
                o.selectedSource = (v === undefined ? d.selectedSource : v);
            } else {
                o.selectedCustomer = d.selectedCustomer;
                o.selectedDestination = d.selectedDestination;
                o.selectedProduct = d.selectedProduct;
                o.selectedProductCategory = d.selectedProductCategory;
                o.selectedSource = d.selectedSource;
                if (GetSetting(settings, "MustInputProduct") || d.selectedProduct === null) {
                    trans.current.productId = 0;
                } else {
                    trans.current.productId = parseInt(d.selectedProduct.id);
                }
                if (d.selectedCustomer !== null) trans.current.customerId = parseInt(d.selectedCustomer.id);
                if (d.selectedSource !== null) trans.current.sourceId = parseInt(d.selectedSource.id);
                if (d.selectedDestination !== null) trans.current.destinationId = parseInt(d.selectedDestination.id);
            }
            o.selectedTruckConfig = d.selectedVehicleConfiguration;
            o.deliveryAddress = d.deliveryAddress;
            o.haulage = d.haulage;
            setOptions(o);
            o.prices = d.prices;
            jobOptions.current = o;
            if (cb === "JobCallback") DisplayNextPrompt("JobCallback");
        }).catch((error) => {
            console.log("SetControlsForJob fetch error: " + error.message);
        });
    }

    const GetCustomerJobs = (c) => {
        var url = `${configData.SERVER_URL}apiv7/jobs?$filter=customerid eq ${c}`;
        const init = {
            method: 'GET',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() }
        }
        fetch(url, init).then(response => response.json()).then(d => {
            let j = [];
            d.map((x) => {
                j.push({ id: x.jobId, name: x.name });
            });
            jobOptions.current.jobs = j;
            DisplayNextPrompt("JobCallback");
        }).catch((error) => {
            console.log("GetCustomerJobs fetch error: " + error.message);
        });
    }

    const ShowStream = (s) => {
        let u = GetStreamingUrl(s, businessData.current);
        setStreamUrl(u);
    }

    const CloseStreaming = () => {
        setStreamUrl(undefined);
    }

    const ShowItemSelector = (options, callback, type, keyboard = true, hidecodes = false) => {
        setItemSelectorType(type);
        setShowItemSelector(true);
        setItemSelectorShowCodes(hidecodes !== true && GetSetting(settings, "ItemSelectorShowCodes"));
        setItemSelectorLayout("default");
        setItemSelectorCallback(callback);
        setItemShowKeyboard(keyboard)
        setItemSelectorOptions(options);
    }

    const ToggleSlider = () => {
        setShowWeightSlider(!showWeightSlider);
    }

    const RegoFocus = () => {
        if (GetSetting(settings, "UseKeyboardforRego")) PromptForRego();
    }

    const PromptForRego = () => {
        PromptForText("Rego");
        setItemSelectorLayout("rego");
    }

    const TextEnteredCallback = (type, t) => {
        setTextEntryType("");
        const init = {
            method: 'GET',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() },
            cache: "no-cache"
        };
        let commTitle = GetSetting(settings, "CommentTitle");
        switch (type) {
            case "***CANCEL":
                CancelItemSelection();
                break;

            case "Rego":
                setRego(t);
                CheckRego(t);
                break;

            case "Trailer 1 Rego":
                trans.current.registration2 = t;
                trans.current.trailersConfirmed = 1;
                AcceptClicked();
                break;

            case "Trailer 2 Rego":
                trans.current.registration3 = t;
                trans.current.trailersConfirmed = 2;
                AcceptClicked();
                break;

            case "Maximum Load":
                trans.current.maxLoadEntered = parseFloat(t);
                AcceptClicked();
                break;

            case commTitle:
                trans.current.comment = t;
                if (IsAutomated(mode.current))
                    DoAutomated();
                else {
                    if (trans.current.dataPrompted)
                        PreviewTransaction();
                    else
                        AcceptClicked();
                }
                break;

            case "Voucher":
                if (t == "") {
                    setDialogError("Voucher Cleared");
                    setVoucher("");
                    trans.current.voucher = "";
                    RecalculatePrice();
                    return;
                }
                var url = `${configData.SERVER_URL}apiv7/vouchers/checkvouchercode?code=${t}`;

                fetch(url, init).then(response => response.json()).then(d => {
                    if (d.status !== undefined && d.status >= 300) {
                        setDialogError("Voucher not found");
                        setVoucher("");
                    } else {
                        let dt = new Date();
                        let from = new Date(Date.parse("1/1/1"));
                        if (d.startDate !== null) from = new Date(Date.parse(d.startDate));
                        if (from > dt) {
                            setDialogError(`Voucher not valid until ${from.getDate()}/${from.getMonth()}/${from.getFullYear()}`);
                            setVoucher("");
                            return;
                        }
                        let todate = new Date(Date.parse("31/12/3000"));
                        if (d.endDate !== null) todate = new Date(Date.parse(d.endDate));
                        if (dt > todate) {
                            setDialogError("Voucher has expired");
                            setVoucher("");
                            return;
                        }
                        if (d.totalUses >= d.usesAllowed) {
                            setDialogError("Voucher has been used already");
                            setVoucher("");
                            return;
                        }
                        setVoucher(d);
                        trans.current.voucher = d.code;
                        RecalculatePrice();
                    }
                }).catch((error) => {
                    console.log("Check voucher coded fetch error: " + error.message);
                });
                break;

            case "Order Number":
                trans.current.orderNumber = t;
                AcceptClicked();
                break;
            case "VIN":
                trans.current.vinNumber = t;
                DisplayNextPrompt("");
                break;
            case "Visitor Name":
            case "Visitor Company":
            case "Visitor Phone":
                DisplayNextPrompt(t);
                break;

            case "Reason for Visit":
                trans.current.visitorReason = t;
                LogVisitorTransaction();
                AbortAndOpenGate();
                break;

            case "Plant Number":
                trans.current.registration1 = t;
                url = `${configData.SERVER_URL}apiv7/trucks?$filter=Name eq '${t}'`;
                fetch(url, init).then(response => response.json()).then(d => {
                    if (d.length === 0) {
                        trans.current.registration1 = "";
                        setDialogError(`The entered plant number ${t} not present in the system. Please check with site administrator.`);
                        return;
                    }
                    trans.current.maxLoad1 = d[0].maxLoad;
                    trans.current.maxLoad = d[0].maxLoad;
                    setShowTruckConfig(true);
                }).catch((error) => {
                    console.log("Lookup plant number fetch error: " + error.message);
                });
                break;

            case "Comment":
                trans.current.comment = t;
                AcceptClicked();
                break;

            case "Trailer Number":
                if (t === "***1") {
                    setShowTruckConfig(true);
                    return;
                }
                if (t === "***2") {
                    trans.current.registration2 = "";
                    trans.current.maxLoad2 = 0;
                    trans.current.maxLoad = trans.current.maxLoad1;
                    return;
                }
                trans.current.registration2 = t;
                url = `${configData.SERVER_URL}apiv7/trucks?$filter=Name eq '${t}'`;
                fetch(url, init).then(response => response.json()).then(d => {
                    if (d.length === 0) {
                        trans.current.registration2 = "";
                        setDialogError(`The entered trailer number ${t} not present in the system. Please check with site administrator.`);
                        return;
                    }
                    trans.current.maxLoad2 = d[0].maxLoad;
                    trans.current.maxLoad = trans.current.maxLoad1 + d[0].maxLoad;
                }).catch((error) => {
                    console.log("Lookup trailer number fetch error: " + error.message);
                });
                break;
        }
    }

    const LogVisitorTransaction = () => {
        let t = GetTransactionData(trans.current, site.current, settings, allOptions.current);
        PostTransaction(t, ResponseCallback);
    }

    const LoadTypeChanged = (e) => {
        if (firstWeigh.current !== null && firstWeigh.current !== undefined) return; // cannot change loadtype when firstweigh recalled
        let id = String(e.target.innerText);
        if (id.length === 2 && id.startsWith("M")) id = "COUNTED";
        if (id === "STORED") id = "STOREDTARE";
        setLoadType(id);
        trans.current.loadType = id;
        ClearSelections();
        switch (id) {
            case "STANDARD":
            case "COUNTED":
                setShowFirstWeighTable(false);
                setShowLookup(false);
                setShowOptions(false);
                var sh = currentRego.current.length > 0;
                if (id === "COUNTED" && (trans.current.selectedMixedProducts === null || trans.current.selectedMixedProducts.length === 0)) sh = false;
                setShowAccept(sh);
                setShowMixedProducts(id === "COUNTED");
                break;
            case "REGO":
            case "VISITOR":
            case "MIXED":
                setShowFirstWeighTable(false);
                setShowLookup(false);
                setShowOptions(false);
                var sh = currentRego.current.length > 0 && weight.current[0] >= GetSetting(settings, "MinimumWeight");
                setShowAccept(sh && (id !== "MIXED" || trans.current.productId > 0));
                setShowMixedProducts(id === "MIXED");
                break;
            case "SIMPLE":
                setShowFirstWeighTable(false);
                setShowLookup(false);
                setShowOptions(false);
                setShowAccept(weight.current[0] >= GetSetting(settings, "MinimumWeight"));
                setShowMixedProducts(false);
                break;
            case "STOREDTARE":
                if (selectedTruck.current !== undefined) {
                    trans.current.tare1 = selectedTruck.current.tare1;
                    trans.current.tare2 = selectedTruck.current.tare2;
                    trans.current.tare3 = selectedTruck.current.tare3;
                    trans.current.tare4 = selectedTruck.current.tare4;
                    trans.current.tare5 = selectedTruck.current.tare5;
                }
                break;
            default:
                var sh = (weights[0] >= GetSetting(settings, "MinimumWeight")) && rego !== "";
                setShowLookup(false);
                setShowAccept(sh);
                setShowMixedProducts(false);
                break;
        }
    }

    const SetWeights = (w) => {
        weight.current[0] = w;
        setWeights(weight.current);
    }

    const RestartClicked = () => {
        GenerateStateEvent("Reset", "");
        TransactionCancelled();
        Restart();
    }

    const AbortAndOpenGate = () => {
        if (GetSetting(settings, "OpenExitOnError")){
            GenerateStateEvent("leave", "Leave");
        } else {
            GenerateStateEvent("Reset", "Wait");
        }
        Restart();
    }

    const Restart = () => {
        setShowPreview(false);
        currentRego.current = "";
        setRegoDisabled(false);
        firstWeigh.current = null;
        product.current = defaultProduct.current;
        previewOn.current = false;
        setShowRegoDiv(true);
        setShowRestart(true);
        setShowSync(!GetSetting(settings, "DisableSyncNowbutton"));
        setShowReprint(GetSetting(settings, "UseReprintMenu"));
        setShowReprintLast(GetSetting(settings, "UseReprintLastMenu"));
        setShowLogSplit(false);
        setShowTraffic(true);
        setShowRemote(!GetSetting(settings, "HideRemoteDisplay"));
        setShowSplit(false);
        setLoadTypeDisabled(!GetSetting(settings, "AllowLoadTypeSelection"));
        setShowCameras(!GetSetting(settings, "HideSurveillanceCameras"));
        UseAllOptions(allOptions.current);
        setItemSelectorOptions([]);
        setRego("");
        setLoadType("");
        regoFound.current = false;
        setShowAccept(false);
        setShowLogSplit(false);
        setShowOptions(false);
        setActiveWeighbridge(activeWeighbridge);
        setShowMixedProducts(false);
        setShowLoadType(true);
        if (GetSetting(settings, "ShowFirstWeighTable")) {
            setShowFirstWeighTable(true);
            setUpdateFirstWeighs(new Date());
        }
        setShowLookup(!GetSetting(settings, "HideLookup1stWeigh"));
        currentSplit.current = 0;
        selectedTruck.current = undefined;
        weight.current = [0, 0, 0, 0, 0, 0];
        setWeights(weight.current);
        overloadOverride.current = false;
        setScaleDisabled(false);
        currentRego.current = "";
        firstWeigh.current = null;
        serverData.current = undefined;
        commentPrompted.current = false;
        trans.current = CreateNewTransaction(settings);
        localStorage.setItem("WBInUse", "false");
        $("#Rego").focus();
    }

    const ReprintClicked = () => { setShowReprintDialog(true); }

    const DisplayNextPrompt = (result) => {
        // Displays the next prompt according to settings. If non remaining, display transaction preview
        // save result from current prompt
        // For jobs need to lookup values on server annd callback is required when date is retreived. Result will be set as "JobCallback" to re-enter business logic
        if (result === "***CANCEL") {
            CancelItemSelection();
            return;
        }
        setShowMixedProducts(false);
        if (result === "JobCallback") {
            result = "Job";
        } else {
            // save the result value in the transaction for the current prompt
            switch (prompt.current) {
                case "Job":
                    trans.current.jobId = result;
                    // For jobs, want to filter other inputs for job. This will call back into DisplayNextPrompt but skip this section
                    SetControlsForJob(result, rego, "JobCallback");
                    return;
                case "Product":
                case "AllProducts":
                    trans.current.productId = result;
                    let pr = allOptions.current.products.find(obj => { return obj.id === String(result) });
                    if (pr !== undefined) {
                        let sp = pr.data.split(',');
                        if (sp.length > 3) trans.current.direction = sp[3];
                        if (GetSetting(settings, "MustInputProductCategory")) {
                            trans.current.productCategoryId = 0;
                        } else {
                            let pc = allOptions.current.productCategories.find(obj => { return obj.id === sp[0] });
                            if (pc !== undefined) {
                                trans.current.productCategoryId = pc.id;
                                trans.current.isMunicipal = pc.data === "True";
                            }
                        }
                    }
                    break;
                case "ProductCategory":
                    trans.current.productCategoryId = result;
                    let pc = allOptions.current.productCategories.find(obj => { return obj.id === String(result) });
                    if (pc !== undefined) trans.current.isMunicipal = pc.data === "True";
                    break;
                case "Customer":
                    trans.current.customerId = result;
                    let cust = options.customers.find(obj => { return obj.id === String(result) });
                    if (cust !== undefined) {
                        let c = JSON.parse(cust.data);
                        trans.current.orderNumberRequired = c.OrderNumberRequired;
                        trans.current.orderNumberRequiredPerTxn = c.RequiredPerTxn;
                        trans.current.payments = c.Payment;
                        if (c.OrderNumberRequired || c.RequiredPerTxn) {
                            PromptForText("Order Number");
                            return;
                        }
                    }
                    break;
                case "Destination": trans.current.destinationId = result; break;
                case "Source": trans.current.sourceId = result; break;
                case "TruckConfig": trans.current.vehicleConfigurationId = result; break;
                case "Vehicles": trans.current.vehicleId = result; break;
                case "VisitorType": trans.current.visitorType = result; break;
                case "VisitorName": trans.current.visitorName = result; break;
                case "VisitorCompany": trans.current.visitorOrg = result; break;
                case "VisitorContact": trans.current.visitorPhone = result; break;
                case "VisitorReason": trans.current.visitorReason = result; break;
                case "WasteStream":
                    let ws = WasteStreams.find(obj => { return obj.code === result });
                    if (ws !== undefined) trans.current.subStream = ws.name;
                    prompt.current = "ProductCategory";
                    break;
                case "DestinationPurpose":
                    let dp = DestinationPurposes.find(obj => { return obj.code === result });
                    if (dp !== undefined) trans.current.destinationPurpose = dp.name;
                    prompt.current = "ProductCategory";
                    break;
            }
        }
        // Find the next data to display. 
        // If an option has already been selected skip that option.
        // If there is only one choice available, use that option and skip it
        let skip = true;
        let enterSecond = loadType === "SECOND" && GetSetting(settings, "IgnoreFirstWeighEntityPrompts");
        do {
            if (loadType !== "VISITOR" && loadType !== "REGO" && trans.current.productCategoryId > 1 && allOptions.current.isEPA &&
                ((trans.current.isMunicipal && trans.current.subStream === "") || (!trans.current.isMunicipal && trans.current.destinationPurpose === "" && trans.current.direction === "OUT"))) {
                if (trans.current.isMunicipal)
                    prompt.current = "WasteStream";
                else
                    prompt.current = "DestinationPurpose";
            } else {
                switch (loadType) {
                    case "STANDARD": // standard does Vehicles, AllProducts then any MUST Enter prompts
                        switch (prompt.current) {
                            case "": prompt.current = "Vehicles"; break;
                            case "Vehicles": prompt.current = "AllProducts"; break;
                            case "AllProducts": prompt.current = GetNextPromptType(settings, "", trans.current.loadType); break;
                            default: prompt.current = GetNextPromptType(settings, prompt.current, trans.current.loadType); break;
                        }
                        break;
                    case "VISITOR": prompt.current = GetNextVisitorPrompt(prompt.current); break;
                    case "REGO": // Rego is all product then MUST Enter prompt
                        switch (prompt.current) {
                            case "": prompt.current = "AllProducts"; break;
                            case "AllProducts": prompt.current = GetNextPromptType(settings, "", trans.current.loadType); break;
                            default: prompt.current = GetNextPromptType(settings, prompt.current, trans.current.loadType); break;
                        }
                        break;
                    case "MIXED":
                        prompt.current = GetNextMixedPrompt(prompt.current);
                        break;
                    case "FIRST":
                        if (GetSetting(settings, "IgnoreFirstWeighEntityPrompts"))
                            prompt.current = "";
                        else
                            prompt.current = GetNextPromptType(settings, prompt.current, trans.current.loadType);
                        break;
                    default: prompt.current = GetNextPromptType(settings, prompt.current, trans.current.loadType); break;
                }
            }
            switch (prompt.current) {
                case "Job":
                    if (jobOptions.current.jobs === undefined || trans.current.jobId === 0 || (enterSecond && trans.current.jobId === 1)) {
                        if (jobOptions.current.jobs.length <= 1) {
                            trans.current.jobId = (jobOptions.current.jobs === undefined || jobOptions.current.jobs.length === 0) ? 1 : parseInt(jobOptions.current.jobs[0].id);
                        } else {
                            skip = false;
                        }
                    }
                    break;
                case "Product":
                    if (trans.current.productId === 0 || (enterSecond && trans.current.productId === 1 && !GetSetting(settings, "MustInputProduct"))) {
                        if (jobOptions.current.products === undefined || jobOptions.current.products.length <= 1) {
                            trans.current.productId = (jobOptions.current.products === undefined || jobOptions.current.products.length === 0) ? 1 : parseInt(jobOptions.current.products[0].id);
                        } else {
                            skip = false;
                        }
                    }
                    break;
                case "ProductCategory":
                    if (trans.current.productCategoryId === 0 || (enterSecond && trans.current.productCategoryId === 1)) {
                        if (jobOptions.current.productCategories === undefined || jobOptions.current.productCategories.length <= 1) {
                            trans.current.productCategoryId = (jobOptions.current.productCategories === undefined || jobOptions.current.productCategories .length === 0) ? 1 : parseInt(jobOptions.current.productCategories[0].id);
                        } else {
                            skip = false;
                        }
                    }
                    break;
                case "Customer":
                    if (trans.current.customerId === 0 || (enterSecond && trans.current.customerId === 1)) {
                        if (jobOptions.current.customers === undefined || jobOptions.current.customers.length === 1) {
                            trans.current.customerId = jobOptions.current.customers === undefined ? 1 : parseInt(jobOptions.current.customers[0].id);
                            let c = serverData.current.customers.find(obj => { if (obj.id == String(trans.current.customerId)) return obj; });
                            let opt = JSON.parse(c.data);
                            trans.current.orderNumberRequiredPerTxn = opt.RequiredPerTxn;
                            trans.current.orderNumberRequired = opt.OrderNumberRequired;
                            if ((opt.OrderNumberRequired || opt.RequiredPerTxn) && trans.current.orderNumber === "") {
                                PromptForText("Order Number");
                                return;
                            }
                        } else {
                            skip = false;
                        }
                    }
                    break;
                case "Destination":
                    if (trans.current.destinationId === 0 || (enterSecond && trans.current.destinationId === 1)) {
                        if (jobOptions.current.destinations === undefined || jobOptions.current.destinations.length <= 1) {
                            trans.current.destinationId = (jobOptions.current.destinations === undefined || jobOptions.current.destinations.length === 0) ? 1 : parseInt(jobOptions.current.destinations[0].id);
                        } else {
                            skip = false;
                        }
                    }
                    break;
                case "Source":
                    if (trans.current.sourceId === 0 || (enterSecond && trans.current.sourceId === 1)) {
                        if (jobOptions.current.sources === undefined || jobOptions.current.sources.length <= 1) {
                            trans.current.sourceId = (jobOptions.current.sources === undefined || jobOptions.current.sources.length === 0) ? 1 : parseInt(jobOptions.current.sources[0].id);
                        } else {
                            skip = false;
                        }
                    }
                    break;
                case "TruckConfig":
                    if (trans.current.vehicleConfigurationId === 0 || (enterSecond && trans.current.vehicleConfigurationId === 1)) {
                        if (jobOptions.current.truckConfigs === undefined || jobOptions.current.truckConfigs.length <= 1) {
                            trans.current.vehicleConfigurationId = (jobOptions.current.truckConfigs === undefined || jobOptions.current.truckConfigs .length === 0) ? 1 : parseInt(jobOptions.current.truckConfigs[0].id);
                        } else {
                            skip = false;
                        }
                    }
                    break;
                case "Vehicles":
                    if (trans.current.vehicleId <= 1) {
                        if (jobOptions.current.vehicles === undefined || jobOptions.current.vehicles.length <= 1) {
                            trans.current.vehicleId = (jobOptions.current.vehicles === undefined || jobOptions.current.vehicles.length === 0) ? 1 : parseInt(jobOptions.current.vehicles[0].id);
                        } else {
                            skip = false;
                        }
                    }
                    break;
                case "AllProducts":
                case "VisitorType":
                case "VisitorName":
                case "VisitorCompany":
                case "VisitorContact":
                case "VisitorReason":
                case "WasteStream":
                case "DestinationPurpose":
                    skip = false;
                    break;
                case "":
                    skip = false;
                    break;
            }
        } while (skip);
        // Display the next selection prompt
        switch (prompt.current) {
            case "": // nothing to select - jump to transaction preview
                setShowItemSelector(false);
                trans.current.dataPrompted = true;
                if (GetSetting(settings, "UseCommentPad") && !GetSetting(settings, "PromptCommentBeforeWeight") && !commentPrompted.current) {
                    PromptForComment();
                    return;
                }
                PreviewTransaction();
                return;
            case "Job":
                if (GetSetting(settings, "PromptCustomerFirstInDataSelection") && result !== "Job") {
                    // filter jobs by customer
                    prompt.current = "Customer";
                    GetCustomerJobs(result);
                } else {
                    // show all jobs
                    let j = jobOptions.current.jobs;
                    if (!GetSetting(settings, "ShowNAinJobPopupWindowList")) {
                        j = [];
                        jobOptions.current.jobs.map((x) => {
                            if (x.id !== "1") {
                                j.push(x);
                            }
                        });
                    }
                    ShowItemSelector(GetSelectionItems(j, GetSetting(settings, "MustInputJob")), () => DisplayNextPrompt, "Job"); 
                }
                break;
            case "Product":
                let prod = loadType === "SIMPLE" ? [...allOptions.current.weighedProducts] : [...jobOptions.current.products ];
                ShowItemSelector(GetSelectionItems(prod, GetSetting(settings, "MustInputProduct")), () => DisplayNextPrompt, "Product", true);
                break;
            case "ProductCategory": ShowItemSelector(GetSelectionItems(jobOptions.current.productCategories, GetSetting(settings, "MustInputProductCategory")), () => DisplayNextPrompt, "ProductCategory", true); break;
            case "Customer": ShowItemSelector(GetSelectionItems(jobOptions.current.customers, GetSetting(settings, "MustInputCustomer")), () => DisplayNextPrompt, "Customer", true); break;
            case "Destination": ShowItemSelector(GetSelectionItems(jobOptions.current.destinations, GetSetting(settings, "MustInputDestination")), () => DisplayNextPrompt, "Destination", true); break;
            case "Source": ShowItemSelector(GetSelectionItems(jobOptions.current.sources, GetSetting(settings, "MustInputSource")), () => DisplayNextPrompt, "Source", true); break;
            case "TruckConfig": ShowItemSelector(GetSelectionItems(jobOptions.current.truckConfigs, GetSetting(settings, "MustInputVehicleConfiguration")), () => DisplayNextPrompt, "TruckConfig", true); break;
            case "Vehicles": ShowItemSelector(GetSelectionItems(allOptions.current.vehicles, false), () => DisplayNextPrompt, "Vehicles", true); break;
            case "AllProducts": ShowItemSelector(GetSelectionItems(allOptions.current.products, false), () => DisplayNextPrompt, "Product", true); break;
            case "WasteStream": ShowItemSelector(WasteStreams, () => DisplayNextPrompt, "Waste Stream", true); break;
            case "DestinationPurpose": ShowItemSelector(DestinationPurposes, () => DisplayNextPrompt, "Destination Purpose", true); break;
            case "VisitorType":
                let itms = [];
                itms.push({ code: "Visitor", name: "Visitor" });
                itms.push({ code: "Service Vehicle", name: "Service Vehicle" });
                ShowItemSelector(itms, () => DisplayNextPrompt, "Visitor Type", false, true); break;
            case "VisitorName": PromptForText("Visitor Name", trans.current.visitorName); break;
            case "VisitorCompany": PromptForText("Visitor Company", trans.current.visitorOrg); break;
            case "VisitorContact": PromptForText("Visitor Phone", trans.current.visitorPhone); break;
            case "VisitorReason": PromptForText("Reason for Visit", trans.current.visitorReason); break;
        }
    }

    const CancelItemSelection = () => {
        setItemSelectorOptions([]);
    }

    const PreviewTransaction = () => {
        setShowRegoDiv(false);
        setShowOptions(false);
        setShowRestart(false);
        setShowSync(false);
        setShowReprint(false);
        setShowReprintLast(false);
        setShowLogSplit(false);
        setShowLoadType(false);
        setShowSplit(false);
        setShowTraffic(false);
        setShowRemote(false);
        setShowCameras(false);
        setShowFirstWeighTable(false);
        previewOn.current = true;
        setShowPreview(true);
        setTransaction(trans.current);
        if (GetSetting(settings, "SaveSnapshotsInTransaction")) DoSnapshots();
        let info = [];
        switch (trans.current.loadType) {
            case "STANDARD":
                let vn = allOptions.current.vehicles.find(obj => { return obj.id === String(trans.current.vehicleId) });
                info = [
                    { "name": GetField(layout, "loadType")["label"], "value": trans.current.loadType },
                    { "name": "Vehicle Type", "value": vn.name },
                    { "name": GetField(layout, "rego")["label"], "value": rego }
                ];
                break;
            case "MIXED":
            case "COUNTED":
                info = [
                    { "name": GetField(layout, "rego")["label"], "value": rego },
                    { "name": GetField(layout, "loadType")["label"], "value": trans.current.loadType },
                ];
                break;
            default:
                info = [
                    { "name": GetField(layout, "rego")["label"], "value": rego },
                    { "name": GetField(layout, "loadType")["label"], "value": trans.current.loadType },
                    { "name": GetField(layout, "tare")["label"] + " 1", "value": trans.current.tare1.toFixed(2) + "t" },
                    { "name": GetField(layout, "tare")["label"] + " 2", "value": trans.current.tare2.toFixed(2) + "t" },
                    { "name": GetField(layout, "tare")["label"] + " 3", "value": trans.current.tare3.toFixed(2) + "t" },
                    { "name": GetField(layout, "tare")["label"] + " 4", "value": trans.current.tare4.toFixed(2) + "t" },
                ];
                break;
        }
        setTransInfo(info);
    }

    // control changed on Preview page
    const PreviewSelection = (type, val) => {
        switch (type) {
            case "Payment":
                trans.current.payments = val;
                if (val.toLowerCase() === "voucher") {
                    PromptForText("Voucher");
                }
                break;
            case "Direction": trans.current.direction = val; break;
            case "Rate": trans.current.chargeRate = val; break;
            case "Owner": trans.current.vehicleOwner = val; break;
            case "Delivery": trans.current.cartageCharge = val; break;
            case "Penalty": trans.current.penaltyCharge = val; break;
            case "Comment": trans.current.comment = val; break;
        }
        RecalculatePrice();
    }

    const PromptForText = (t, def = "") => {
        setItemSelectorLayout("default");
        setTextEntryType(t);
        setTextEntryInitial(def);
        setTextEntryExtra("");
        setTextEntryExtra2("");
    }

    // Print docket or Back on preview screen
    const PreviewClosed = (save) => {
        if (GetSetting(settings, "MustEnterSignature")) {
            if (signature !== undefined && signature.value !== undefined) {
                if (signature.value === "") {
                    setDialogError("Please sign the docket");
                    return;
                }
            }
        }
        if (save) {
            let t = GetTransactionData(trans.current, site.current, settings, allOptions.current);
            PostTransaction(t, ResponseCallback);
        } else {
            FinalizeTransaction();
        }
    }

    const ResponseCallback = (r) => {
        if (r.result === 0) {
            if (loadType === "SECOND") DeleteLocalFirstWeigh(trans.current.registration1);
            let r = regoList.current.find(obj => { return obj === trans.current.registration1 });
            if (r === undefined) regoList.current.push(trans.current.registration1);
            setDocket("Last Docket:" + trans.current.docket);
            transactionWait.current.ready = false;
            Restart();
            localStorage.setItem("DocketNumber", "");
        } else {
            ShowError(r.message);
        }
    }

    const FinalizeTransaction = () => {
        previewOn.current = false;
        localStorage.setItem("DocketNumber", "");
        setShowPreview(false);
        setShowRegoDiv(true);
        setShowRestart(true);
        setShowSync(!GetSetting(settings, "DisableSyncNowbutton"));
        setShowReprint(GetSetting(settings, "UseReprintMenu"));
        setShowReprintLast(GetSetting(settings, "UseReprintLastMenu"));
        setShowLogSplit(false);
        setShowTraffic(true);
        setShowRemote(!GetSetting(settings, "HideRemoteDisplay"));
        setShowCameras(!GetSetting(settings, "HideSurveillanceCameras"));
        setShowSplit(true);
        setScaleDisabled(false);
        setShowLoadType(true);
        if (trans.current.loadType === "COUNTED" || trans.current.loadType === "MIXED")
            setShowMixedProducts(true);
        else
            setShowOptions(GetSetting(settings, "AllowTranslinkSelection"));
    }

    const ClearAllSelections = () => {
        let o = { ...options };
        if (allOptions.current !== undefined) {
            o.customers = allOptions.current.customers;
            o.destinations = allOptions.current.destinations;
            truckJobs.current = allOptions.current.jobs;
            o.jobs = allOptions.current.jobs;
            o.products = allOptions.current.products;
            o.productCategories = allOptions.current.productCategories;
            o.sources = allOptions.current.sources;
            o.truckConfigs = allOptions.current.vehicleConfigurations;
        }
        o.selectedCustomer = {id : "0", name : "", data : ""};
        o.selectedDestination = { id: "0", name: "", data: "" };
        o.selectedJob = { id: "0", name: "", data: "" };
        o.selectedProduct = { id: "0", name: "", data: "" };
        o.selectedProductCategory = { id: "0", name: "", data: "" };
        o.selectedSource = { id: "0", name: "", data: "" };
        o.selectedTruckConfig = { id: "0", name: "", data: "" };
        o.deliveryAddress = "";
        setOptions(o);
    }

    const CheckOverload = () => {
        // process overload logic:
        // if EnableOverloadTransaction is false, allow no overloads: HARD Logic
        // if overload < OverloadWarningAllowance, just ignore
        // if overload > MaxLoadExceedAllowance (%), stop transaction: HARD/SOFT
        // if between those limited display up to DailyOverloadsAllowed warnings: HARD/SOFT
        // For last 2, if OperatorCannotOverrideOverload transaction is stopped (Hard), otherwise Yes/No dialog (soft)

        if (overloadOverride.current) return true; // if previously overridden just continue
        if (serverData.current === undefined) return true; // for some load type these is no rego requirement
        let wt = weights[0];
        let maxLoadWarnings = 0;
        let lastVisit = null;
        let maxLoad = GetSetting(settings, "MaximumWeight");
        if (serverData.current.truck !== undefined && serverData.current.truck !== null) {
            maxLoad = serverData.current.truck.maxLoad;
            maxLoadWarnings = serverData.current.truck.percentOverloadWarnings;
            lastVisit = serverData.current.truck.lastVisit;
        } else {
            if (serverData.current.firstWeigh !== null) {
                maxLoad = serverData.current.firstWeigh.maxLoad;
                maxLoadWarnings = serverData.current.firstWeigh.maxLoadWarnings;
            }
        }
        if (maxLoad === 0) return true; // if maxLoad is not set cannot enforce it
        let absMax = maxLoad;
        if (GetSetting(settings, "EnableOverloadTransaction")) absMax = (1 + GetSetting(settings, "MaxLoadExceedAllowance") / 100) * maxLoad;
        let minWarn = ((1 + GetSetting(settings, "OverloadWarningAllowance") / 100) * maxLoad).toFixed(2);
        let over = (wt - maxLoad).toFixed(2);
        let msg = "";
        let allowance = (GetSetting(settings, "OverloadWarningAllowance")) ;
        if (wt > maxLoad && !GetSetting(settings, "EnableOverloadTransaction")) {
            msg = `Vehicle Maximum Exceeded. You must tip off. <br/>Maximum truck load is ${maxLoad}t, overloaded by ${over}t.`;
            ShowError(msg);
            trans.current.eventType = 7;
            trans.current.eventLogError = "Overload";
            trans.current.eventLogDescription = msg;
            PostEventLog(trans.current);
            GenerateStateEvent("leave", "TipOff");
            Restart();
            return false;
        }
        if (wt > absMax) {
            if (GetSetting(settings, "OperatorCannotOverrideOverload")) {
                msg = `Vehicle Maximum Exceeded. You must tip off. <br/>Maximum truck load is ${maxLoad}t, overloaded by ${over}t.`;
                ShowError(msg);
                GenerateStateEvent("leave", "TipOff");
                trans.current.eventType = 7;
                trans.current.eventLogError = "Overload";
                trans.current.eventLogDescription = msg;
                PostEventLog(trans.current);
                Restart();
                return false;
            } else {
                ShowDialog(`The vehicle exceeded ${allowance}% over the vehicle's legal weight. Max truck load is ${maxLoad}t, overloaded by ${over}t.`, OverloadAllowed, "Confirm Overload");
                return false;
            }
        }
        if (lastVisit === null) return true;
        let lv = new Date(Date.parse(lastVisit + "Z"));
        let n = new Date();
        if (lv.getFullYear() !== n.getFullYear() || lv.getMonth() !== n.getMonth() || lv.getDate() !== n.getDate()) return true;
        let daily = maxLoadWarnings;
        if (wt < maxLoad) return true;
        let dailyAllowed = GetSetting(settings, "DailyOverloadsAllowed");
        if (dailyAllowed === 0) {
            ShowDialog(`The vehicle exceeded ${allowance}% over the vehicle's legal weight. Max truck load is ${maxLoad}t, overloaded by ${over}t.`, OverloadAllowed, "Confirm Overload");
            return false;
        }
        if (daily > dailyAllowed) {
            if (GetSetting(settings, "OperatorCannotOverrideOverload")) {
                msg = `The vehicle maximum load already exceeded ${daily} times today. <br/>Cannot proceed with the transaction.`;
                ShowError(msg);
                trans.current.eventType = 7;
                trans.current.eventLogError = "Overload";
                trans.current.eventLogDescription = msg;
                PostEventLog(trans.current);
                GenerateStateEvent("Reset", "Leave");
                Restart();
                return false;
            } else {
                ShowDialog(`The vehicle max load already exceeded ${daily} times today. <br/>Click Yes to proceed with the transaction.`, OverloadAllowed, "Confirm Overload");
                return false;
            }
        } else {
            // give a specific warning for the nth overload
            daily++;
            trans.current.maxLoadWarnings = daily;
            let n = GetWarningText(daily);
            msg = `${n} WARNING. Vehicle maximum load exceeded. <br/>Max truck load is ${maxLoad}t, overloaded by ${over}t.`;
            ShowDialog(msg, OverloadAllowed, "Confirm Overload");
            trans.current.eventType = 7;
            trans.current.eventLogError = "Overload";
            trans.current.eventLogDescription = msg;
            PostEventLog(trans.current);
            return false;
        }
        return true;
    }

    const ClearSelections = () => {
        trans.current.productCategoryId = 0;
        trans.current.productId = 0;
        trans.current.customerId = 0;
        trans.current.destinationId = 0;
        trans.current.sourceId = 0;
        trans.current.jobId = 0;
        trans.current.truckId = 1;
        trans.current.vehicleId = 1;
        trans.current.driverId = 1;
        commentPrompted.current = false;
        trans.current.comment = "";
        trans.current.orderNumber = ""
    }

    const OverloadAllowed = () => {
        overloadOverride.current = true;
        AcceptClicked();
    }

    const DoAutomated = () => {
        if (weights[0] >= GetSetting(settings, "MinimumWeight") && rego !== "" && loadType !== "") AcceptClicked();
        if (mode.current === "instructions") DoInstructions();
    }

    const DoInstructions = () => {
        ShowError("Please drive onto weighbridge and follow instructions on remote display.");
    }

    const PromptForComment = () => {
        let ttl = GetSetting(settings, "CommentTitle");
        if (ttl === undefined || ttl === "") ttl = "Comment";
        commentPrompted.current = true;
        PromptForText(ttl, "");
    }

    const ChangeScale = (s) => {
        setActiveWeighbridge(s);
        activeScale.current = s;
        let x = { ...businessData.current };
        businessData.current = x;
        var url = `${configData.SERVER_URL}clientapi/weighbridge/setactiveindicator?name=${s}`;
        const init = {
            method: 'POST',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache"
        }
        fetch(url, init);
        
    }

    const SetWeighedProduct = (p) => {
        trans.current.productId = p.productId;
        setShowAccept(true);
    }

    const UpdateMixedProducts = (c) => {
        trans.current.selectedMixedProducts = c;
        var sh = (currentRego.current.length > 0) && (c !== null && c.length > 0);
        if (trans.current.loadType === "MIXED" && trans.current.productId === 0) sh = false;
        setShowAccept(sh);
    }

    const TruckConfigSelected = (s) => {
        setShowTruckConfig(false);
        if (s.indexOf("***CANCEL") === 0) return;
        if (s.indexOf("***BACK") === 0) {
            PromptForText("Plant Number");
            return;
        }
        let tc = allOptions.current.vehicleConfigurations.find(obj => obj.id === s);
        trans.current.vehicleConfigurationId = parseInt(s);
        trans.current.configName = tc.name;
        PromptForText("Trailer Number");
        setTextEntryExtra("Back");
        setTextEntryExtra2("No trailer");
    }

    const HIDClick = (b) => {
        switch (b) {
            case "Cancel":
                ShowDialog("Are you sure you want to cancel this transaction?", Restart);
                break;
            case "Back":
                PromptForText("Trailer Number");
                setTextEntryExtra("Back");
                setTextEntryExtra2("No trailer");
                break;
            case "Confirm":
                AcceptClicked();
                break;
        }
    }

    const CheckUnsavedData = (ev) => {
        if (!trans.current.suppressScanning) {
            return "";
        }
        ev.preventDefault();
        ev.returnValue = "";
    }

    const MoveCameras = (e) => {
        let cp = { "left": e.left, "top": e.top, "width": e.width, "height": e.height };
        localStorage.setItem("WBCameras", JSON.stringify(cp));
    }

    const TakeControlClicked = () => {
        if (!serverState.current.isIdle) return;
        var url = `${configData.SERVER_URL}clientapi/weighbridge/takecontrol`;
        const init = {
            method: 'POST',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache"
        }
        fetch(url, init);
    }

    const DoSnapshots = () => {
        var url = `${configData.SERVER_URL}clientapi/weighbridge/dosnapshots?docket=${trans.current.docket}-${trans.current.loadType}`;
        const init = {
            method: 'GET',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache"
        }
        fetch(url, init);
    }

    const RecaptureClicked = () => {
        CheckRego("");
        setRego("");
    }

    const NoButton = (props) => { return (<div></div>); }
    const CloseReprint = () => { setShowReprintDialog(false); }

    const ProcessServerMessages = () => {
        let sp = serverMessage.current.toLocaleUpperCase().split(',');
        sp.forEach((m, ind) => {
            switch (m) {
                case "TRUCKS":
                    GetRegoList();
                    break;
                case "SYNC":
                    setShowSync(true);
                    break;
                case "UPDATE":
                    RefreshOptions();
                    break;
            }
        });
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };
        let url = `${configData.SERVER_URL}clientapi/weighbridge/clearservermessage`;
        fetch(url, init);
    }

    const SyncClicked = () => {
        setShowSync(false);
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };
        let url = `${configData.SERVER_URL}clientapi/weighbridge/syncnow`;
        fetch(url, init);
    }

    const GetDocketNumber = () => {
        // Check if docket number has previously been assigned. If so, use it
        if (trans.current === undefined || loadType.toUpperCase() === "FIRST" || (trans.current.docketNo !== undefined && trans.current.docketNo !== "")) return;
        let d = localStorage.getItem("DocketNumber");
        if (d.length > 20) d = "";
        if (d !== undefined && d !== null && d !== "") {
            if (trans.current.docket !== d) {
                trans.current.docket = d;
                setDocket("Docket:" + d);
            }
            return;
        }
        if (cloudToken.current === undefined || cloudToken.current === "") {
            GetOfflineDocket();
        }
        else {
            const init = {
                method: 'GET',
                accept: 'application/json',
                headers: { "Authorization": "Bearer " + cloudToken.current }
            }
            let baseUrl = `${GetSession().CloudURL}apiv7/docketnumber/online?siteid=${GetSession().SiteID}`;
            console.log(baseUrl);
            fetch(baseUrl, init).then(response => {
                if (response.status < 300)
                    return response.text();
                else
                    GetOfflineDocket();
            }
            ).then(d => {
                if (d.indexOf("<!doctype") === 0) {
                    GetOfflineDocket();
                } else {
                    trans.current.docket = d;
                    localStorage.setItem("DocketNumber", d);
                    setDocket("Docket:" + d);
                }
            });
        }
    }

    const GetOfflineDocket = () => {
        const init = {
            method: 'GET',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() }
        }
        let baseUrl = `${configData.SERVER_URL}apiv7/docketnumber/getoffline?siteid=${GetSession().SiteID}`;
        fetch(baseUrl, init).then(response => response.text()).then(d => {
            trans.current.docket = d;
            localStorage.setItem("DocketNumber", d);
            setDocket("Docket:" + d);
        });
    }

    const RefreshOptions = () => {
        lastUpdated.current = new Date().valueOf();
        let url = `${configData.SERVER_URL}apiv7/options?userId=${GetUserId()}`;
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };
        fetch(url, init).then(response => response.json()).then(d => {
            if (GetSetting(settings, "DisplaySuppliersAndCustomers")) {
                let c = [...d.customers];
                d.suppliers.map((x) => {
                    c.push({ id: x.id, name: "Sup: " + x.name, data: x.data });
                });
                d.customers = c;
            }
            allOptions.current = d;
            allOptions.current.products = [...d.weighedProducts];
            UseAllOptions(d);
        });

    }

    const ReprintLast = () => {
        const timeOffset = new Date().getTimezoneOffset() / 60;
        const baseUrl = (cloudToken !== undefined && cloudToken !== "" ? GetSession().CloudURL : configData.SERVER_URL);
        const init = {
            method: 'GET',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + (cloudToken.current !== undefined && cloudToken.current !== "" ? cloudToken.current : GetToken()) }
        };
        let url = `${baseUrl}apiv7/private/getdockettext?offset=${timeOffset}`;
        fetch(url, init).then(response => response.text()).then(d => {
            let x = String(d).replace(/\r/g, "").split('\n');
            let t = "";
            x.map(s => {
                let sp = s.split(':');
                if (sp.length > 1) {
                    t += `<tr><td class="ReprintLeft">${sp[0]}</td><td>: ${sp[1]}</td></tr>`;
                } else {
                    t += `<tr><td colspan="2">${s}</td></tr>`
                }
            });
            setReprintText("<table>" + t + "</table>");
            window.onafterprint = () => {
                setReprintText("");
            }
            window.setTimeout(() => { window.print(); }, 200);
        });
    }

    const PostOffence = () => {
        if (offenceRego === "" || offenceDesc === "") {
            setOffenceRegoError(offenceRego === "" ? "Please enter a Rego" : "");
            setOffenceDescError(offenceDesc === "" ? "Please enter a violation comment" : "");
            return;
        }
        var url = `${configData.SERVER_URL}apiv7/offences`;
        var utcDate = new Date().toISOString();
        const init = {
            method: 'POST',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify({
                "name": offenceRego,
                "description": offenceDesc,
                "dateTimeIn": utcDate,
                "siteId": GetSession().SiteID,
                "userId": GetSession().UserId,
                "isActive": true
            })
        }
        fetch(url, init).then(response => {
            setShowOffenceDlg(false);
        });
    }

    return (
        <div style={{ display: "flex" }}>
            {showRegoDiv && <div id="RegoDiv">
                {showKeyboardIcon && <Button className={"showKeyboard"} title="Show keyboard" onClick={PromptForRego}><span style={{ fontFamily: "Wingdings", fontSize: "48pt" }}>7</span></Button>}
                <AutoComplete className="regoLookup" style={{ width: '420px' }} id="Rego" data={regos} value={rego} onFocus={RegoFocus} onChange={RegoChanged} disabled={regoDisabled || !serverState.current.hasControl} placeholder="Enter Rego"></AutoComplete>
                {showLookup && <div><Button className="bigButton" onClick={LookupFirstClicked}>{GetField(layout, "lookup1st")["label"]}</Button></div>}
                {showLogSplit && <div className="logSplit"><Button className="bigButton" onClick={LogSplitClicked}>{GetField(layout, "logSplit")["label"]}</Button></div>}
                {showAccept && <div><Button className="bigButton acceptButton" onClick={AcceptClicked}>{GetField(layout, "accept")["label"]}</Button></div>}
                {showANPR && rego !== "" && <div><Button className="bigButton recaptureButton" onClick={RecaptureClicked}>{GetField(layout, "recapture")["label"]}</Button></div>}
            </div>}
            {showRestart && <div id="Top">
                <div style={{ width: "5px" }}></div>
                {showCameras && <Window id="CameraWindow" closeButton={NoButton} maximizeButton={NoButton} minimizeButton={NoButton} initialLeft={cameraPos.left} initialTop={cameraPos.top} initialWidth={cameraPos.width}
                    initialHeight={cameraPos.height} onMove={MoveCameras} onResize={MoveCameras} title="Cameras">
                    <Cameras snapshots={cameraImages} businessData={businessData.current} showStream={ShowStream} settings={settings} /></Window>}
                {logUpdate !== 0 && <div id="LogsPanelDiv"><Logs businessData={businessData.current} settings={settings} period={logUpdate} /></div>}
                {!showCameras && !showPreview && <div id="NoCameraDiv"></div>}
                {showSync && <div className="syncnow"><Button className="bigButton" onClick={SyncClicked}>Sync Now</Button></div>}
                {showReprint && <div className="reprint"><Button className="bigButton" onClick={ReprintClicked}>{GetField(layout, "reprint")["label"]}</Button></div>}
                {showReprintLast && <div className="reprintlast"><Button className="bigButton" onClick={ReprintLast}>{GetField(layout, "reprintLast", "Reprint Last")["label"]}</Button></div>}
                {showRestart && <div className="restart"><Button className="bigButton" onClick={RestartClicked}>{GetField(layout, "restart")["label"]}</Button></div>}
                {showTakeControl && <div className="takeControl"><Button className="bigButton" onClick={TakeControlClicked}>{takeControl}</Button></div>}
                {showOffence && <div className="offence"><Button className="bigButton" onClick={() => setShowOffenceDlg(true)}>{GetField(layout, "offence", "Offence")["label"]}</Button></div>}
            </div>}
            <div id="WeighBridgePanelDiv"><WeighBridgePanel weights={weights} display={display} lights={lights} settings={settings} wbSettings={wbSettings.current} lightClicked={LightClicked} layout={layout} controlChanged={ChildControlChanged} showSlider={showWeightSlider} setWeights={SetWeights} toggleSlider={ToggleSlider} allowSplit={showSplit} activeScales={activeScales} changeScale={ChangeScale} activeScale={activeWeighbridge} scaleDisabled={scaleDisabled} weightStatus={weightStatus.current} showTraffic={showTraffic} showRemote={showTraffic} options={allOptions.current} splitOn={splitOn} /></div>
            {showLoadType && <div className="loadTypesDiv">
                <div>
                    <label className="control-label">{GetField(layout, "loadType")["label"]}</label>
                    <div className="loadTypeOptions">
                        {GetSetting(settings, "UseStandardLoad") && <div className="loadTypeDiv"><Button selected={loadType === "STANDARD"} onClick={LoadTypeChanged} togglable={true} disabled={loadTypeDisabled}>{GetField(layout, "standard")["label"]}</Button></div>}
                        {GetSetting(settings, "UseCountedItem") && <div className="loadTypeDiv"><Button selected={loadType === "COUNTED"} onClick={LoadTypeChanged} togglable={true} disabled={loadTypeDisabled}>{GetField(layout, "m3")["label"]}</Button></div>}
                        {GetSetting(settings, "UseStoredTare") && <div className="loadTypeDiv"><Button selected={loadType === "STOREDTARE"} onClick={LoadTypeChanged} togglable={true} disabled={loadTypeDisabled || (trans.current !== null && trans.current.tare === 0)}>{GetField(layout, "stored")["label"]}</Button></div>}
                        {GetSetting(settings, "UseFirstWeigh") && <div className="loadTypeDiv"><Button selected={loadType === "FIRST"} onClick={LoadTypeChanged} togglable={true} disabled={loadTypeDisabled}>{GetField(layout, "first")["label"]}</Button></div>}
                        {GetSetting(settings, "UseSecondWeigh") && <div className="loadTypeDiv"><Button selected={loadType === "SECOND"} onClick={LoadTypeChanged} togglable={true} disabled={loadTypeDisabled || (trans.current !== null && !trans.current.hasFirstWeigh)}>{GetField(layout, "second")["label"]}</Button></div>}
                        {GetSetting(settings, "UseRegoWeigh") && <div className="loadTypeDiv"><Button selected={loadType === "REGO"} onClick={LoadTypeChanged} togglable={true} disabled={loadTypeDisabled}>{GetField(layout, "rego")["label"]}</Button></div>}
                        {GetSetting(settings, "UseMixedLoad") && <div className="loadTypeDiv"><Button selected={loadType === "MIXED"} onClick={LoadTypeChanged} togglable={true} disabled={loadTypeDisabled}>{GetField(layout, "mixed")["label"]}</Button></div>}
                        {GetSetting(settings, "UseVisitor") && <div className="loadTypeDiv"><Button selected={loadType === "VISITOR"} onClick={LoadTypeChanged} togglable={true} disabled={loadTypeDisabled}>{GetField(layout, "visitor")["label"]}</Button></div>}
                        {GetSetting(settings, "UseSimple") && <div className="loadTypeDiv"><Button selected={loadType === "SIMPLE"} onClick={LoadTypeChanged} togglable={true} disabled={loadTypeDisabled}>{GetField(layout, "simple")["label"]}</Button></div>}
                    </div>
                </div>
            </div>}
            {showFirstWeighTable && <div id="FirstWeighDiv" className={fwClass}><FirstWeighs firstWeighSelected={FirstWeighSelected} update={updateFirstWeighs} /></div>}
            {settings !== undefined && showOptions && <div id="OperatorDiv">
                <OperatorData layout={layout} settings={settings} options={options} controlChanged={ChildControlChanged} />
            </div>}
            {showMixedProducts && <div id="MixedProductsDiv"><MixedProducts counted={allOptions.current.countedProducts} weighed={allOptions.current.weighedProducts} setWeighedProduct={SetWeighedProduct} updateMixedProducts={UpdateMixedProducts} trans={trans.current} settings={settings} /></div> }
            {settings !== undefined && showPreview && <Preview onClose={PreviewClosed} onSelection={PreviewSelection} layout={layout} settings={settings} transaction={transaction} displayInfo={transInfo} signature={signature} site={site}></Preview>}
            {itemSelectorOptions.length > 0 && <ItemSelector id="ItemSelector" dataType={itemSelectorType} options={itemSelectorOptions} itemSelected={itemSelectorCallback} showDialog={showItemSelector} allowDismiss showCodes={itemSelectorShowCodes} layoutName={itemSelectorLayout} showKeyboard={itemShowKeyboard } />}
            {textEntryType !== "" && <VirtualKeyboardEntry dataType={textEntryType} textEntered={TextEnteredCallback} allowDismiss layoutName={itemSelectorLayout} initialText={textEntryInitial} extraButton={textEntryExtra} extraButton2={textEntryExtra2} />}
            {jobTonnage && <JobTonnage jobTonnage={jobTonnage} callback={JobTonnageCB} />}
            {showHidProcess && <HIDProcess weights={weights} trans={trans.current} buttonClicked={HIDClick} decks={wbSettings.current.Decks} />}
            {showTruckConfig && <TruckConfig options={allOptions.current.vehicleConfigurations} itemSelected={TruckConfigSelected} />}
            {dialogError !== "" && <Dialog title={"Error"} onClose={() => setDialogError("")}>
                <div className="errorMessage" dangerouslySetInnerHTML={{ __html: dialogError }}></div>
                <DialogActionsBar>
                    <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={() => setDialogError("")}>Ok</button>
                </DialogActionsBar>
            </Dialog>}
            {dialogMessage !== "" && <Dialog title={dialogTitle} onClose={DialogNo}>
                <div className="dialogMessage" dangerouslySetInnerHTML={{ __html: dialogMessage }} style={{ minWidth: "300px" }}></div>
                <DialogActionsBar ><div style={{ textAlign: "center" }}>
                    <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base bigButton" onClick={DialogNo} style={{ width: "100px" }}>{dialogNoText}</button>
                    {dialogYesText !== "" && <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base bigButton acceptButton" onClick={DialogYes}>{dialogYesText}</button>}
                </div>
                </DialogActionsBar>
            </Dialog>}
            <Eftpos command={eftposCommand} data={eftposData} callback={EftposCallback}></Eftpos>
            {streamUrl && <div id="StreamWindow"><div id="StreamClose" onClick={CloseStreaming}>X</div><Iframe id="StreamFrame" url={streamUrl}></Iframe></div>}
            <WeighbridgeHeader docketNo={docket} showLogo={!showPreview} site={site.current} />
            {showReprintDialog && <Reprint onClose={CloseReprint} layout={layout} options={allOptions.current} />}
            {reprintText !== "" && <div id="ReprintPage" dangerouslySetInnerHTML={{ __html: reprintText }}></div>}
            {showOffenceDlg && <Dialog title="Add Offence" onClose={() => setShowOffenceDlg(false)}>
                <div className="row">
                    <div className="col-md-3"><Label className="control-label">Rego No</Label></div>
                    <div className="col-md-3"><TextBox id="OffRego" type="text" value={offenceRego} onChange={(e) => setOffenceRego(e.value)} /></div>
                    <div className="col-md-3"><Error>{offenceRegoError}</Error></div>
                </div>
                <div className="row" style={{marginTop: "10px"} }>
                    <div className="col-md-3"><Label className="control-label">Violation Comment</Label></div>
                    <div className="col-md-6"><TextBox id="OffDescription" type="text" value={offenceDesc} onChange={(e) => setOffenceDesc(e.value)} /></div>
                    <div className="col-md-3"><Error>{offenceDescError}</Error></div>
                </div>
                <DialogActionsBar>
                    <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={() => setShowOffenceDlg(false)}>Cancel</button>
                    <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={PostOffence}>Ok</button>
                </DialogActionsBar>
            </Dialog>}
        </div>
    );
}

export default Weighbridge;